/**
 * Slug Comment v3.9.7
 * @author hardylin<hardylin@tencent.com>
 */
import Vue from 'vue';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var O = 'object';
var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == O && globalThis) ||
  check(typeof window == O && window) ||
  check(typeof self == O && self) ||
  check(typeof commonjsGlobal == O && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var descriptors = !fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
var f$1 = descriptors ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$1
};

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
var f$2 = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f$2
};

var hide = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var setGlobal = function (key, value) {
  try {
    hide(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var isPure = false;

var shared = createCommonjsModule(function (module) {
var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.1.3',
  mode:  'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});
});

var functionToString = shared('native-function-to-string', Function.toString);

var WeakMap = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(functionToString.call(WeakMap));

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap) {
  var store = new WeakMap$1();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has$1 = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    hide(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var redefine = createCommonjsModule(function (module) {
var getInternalState = internalState.get;
var enforceInternalState = internalState.enforce;
var TEMPLATE = String(functionToString).split('toString');

shared('inspectSource', function (it) {
  return functionToString.call(it);
});

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) hide(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global_1) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else hide(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || functionToString.call(this);
});
});

var path = global_1;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace])
    : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
	f: f$3
};

var f$4 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$4
};

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      hide(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var Symbol$1 = global_1.Symbol;
var store$1 = shared('wks');

var wellKnownSymbol = function (name) {
  return store$1[name] || (store$1[name] = nativeSymbol && Symbol$1[name]
    || (nativeSymbol ? Symbol$1 : uid)('Symbol.' + name));
};

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  return !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

var IS_CONCAT_SPREADABLE_SUPPORT = !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
_export({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  return O;
};

var html = getBuiltIn('document', 'documentElement');

var IE_PROTO = sharedKey('IE_PROTO');

var PROTOTYPE = 'prototype';
var Empty = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

hiddenKeys[IE_PROTO] = true;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  hide(ArrayPrototype, UNSCOPABLES, objectCreate(null));
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $includes = arrayIncludes.includes;


// `Array.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var nativeAssign = Object.assign;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
// should work with symbols and should have deterministic property order (V8 bug)
var objectAssign = !nativeAssign || fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;
  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
_export({ target: 'Object', stat: true, forced: Object.assign !== objectAssign }, {
  assign: objectAssign
});

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
var objectToString = String(test) !== '[object z]' ? function toString() {
  return '[object ' + classof(this) + ']';
} : test.toString;

var ObjectPrototype = Object.prototype;

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (objectToString !== ObjectPrototype.toString) {
  redefine(ObjectPrototype, 'toString', objectToString, { unsafe: true });
}

var redefineAll = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};

var defineProperty = objectDefineProperty.f;



var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

var setToStringTag = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG$2)) {
    defineProperty(it, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var SPECIES$2 = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty.f;

  if (descriptors && Constructor && !Constructor[SPECIES$2]) {
    defineProperty(Constructor, SPECIES$2, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var aFunction$1 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var anInstance = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var iterators = {};

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$1[ITERATOR] === it);
};

// optional / simple context binding
var bindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var ITERATOR$1 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$1]
    || it['@@iterator']
    || iterators[classof(it)];
};

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};

var iterate_1 = createCommonjsModule(function (module) {
var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bindContext(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  while (!(step = iterator.next()).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};
});

var ITERATOR$2 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var SPECIES$3 = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES$3]) == undefined ? defaultConstructor : aFunction$1(S);
};

var location$1 = global_1.location;
var set$1 = global_1.setImmediate;
var clear = global_1.clearImmediate;
var process$1 = global_1.process;
var MessageChannel = global_1.MessageChannel;
var Dispatch = global_1.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global_1.postMessage(id + '', location$1.protocol + '//' + location$1.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1 || !clear) {
  set$1 = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classofRaw(process$1) == 'process') {
    defer = function (id) {
      process$1.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bindContext(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global_1.addEventListener && typeof postMessage == 'function' && !global_1.importScripts && !fails(post)) {
    defer = post;
    global_1.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in documentCreateElement('script')) {
    defer = function (id) {
      html.appendChild(documentCreateElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task = {
  set: set$1,
  clear: clear
};

var userAgent = getBuiltIn('navigator', 'userAgent') || '';

var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;

var macrotask = task.set;


var MutationObserver = global_1.MutationObserver || global_1.WebKitMutationObserver;
var process$2 = global_1.process;
var Promise$1 = global_1.Promise;
var IS_NODE = classofRaw(process$2) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$2(global_1, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process$2.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE) {
    notify = function () {
      process$2.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !/(iphone|ipod|ipad).*applewebkit/i.test(userAgent)) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global_1, flush);
    };
  }
}

var microtask = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction$1(resolve);
  this.reject = aFunction$1(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
var f$5 = function (C) {
  return new PromiseCapability(C);
};

var newPromiseCapability = {
	f: f$5
};

var promiseResolve = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var hostReportErrors = function (a, b) {
  var console = global_1.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var perform = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var task$1 = task.set;










var SPECIES$4 = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = internalState.get;
var setInternalState = internalState.set;
var getInternalPromiseState = internalState.getterFor(PROMISE);
var PromiseConstructor = global_1[PROMISE];
var TypeError$1 = global_1.TypeError;
var document$2 = global_1.document;
var process$3 = global_1.process;
var $fetch = global_1.fetch;
var versions = process$3 && process$3.versions;
var v8 = versions && versions.v8 || '';
var newPromiseCapability$1 = newPromiseCapability.f;
var newGenericPromiseCapability = newPromiseCapability$1;
var IS_NODE$1 = classofRaw(process$3) == 'process';
var DISPATCH_EVENT = !!(document$2 && document$2.createEvent && global_1.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper;

var FORCED$1 = isForced_1(PROMISE, function () {
  // correct subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var empty = function () { /* empty */ };
  var FakePromise = (promise.constructor = {})[SPECIES$4] = function (exec) {
    exec(empty, empty);
  };
  // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !((IS_NODE$1 || typeof PromiseRejectionEvent == 'function')
    && (!isPure || promise['finally'])
    && promise.then(empty) instanceof FakePromise
    // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // we can't detect it synchronously, so just check versions
    && v8.indexOf('6.6') !== 0
    && userAgent.indexOf('Chrome/66') === -1);
});

var INCORRECT_ITERATION = FORCED$1 || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify$1 = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$2.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global_1['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (promise, state) {
  task$1.call(global_1, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE$1) {
          process$3.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task$1.call(global_1, function () {
    if (IS_NODE$1) {
      process$3.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify$1(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify$1(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED$1) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction$1(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE$1 ? process$3.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify$1(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapability.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  // wrap fetch result
  if ( typeof $fetch == 'function') _export({ global: true, enumerable: true, forced: true }, {
    // eslint-disable-next-line no-unused-vars
    fetch: function fetch(input) {
      return promiseResolve(PromiseConstructor, $fetch.apply(global_1, arguments));
    }
  });
}

_export({ global: true, wrap: true, forced: FORCED$1 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

PromiseWrapper = path[PROMISE];

// statics
_export({ target: PROMISE, stat: true, forced: FORCED$1 }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability$1(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

_export({ target: PROMISE, stat: true, forced:  FORCED$1 }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve( this, x);
  }
});

_export({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability$1(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate_1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability$1(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction$1(C.resolve);
      iterate_1(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec = patchedExec;

_export({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$1 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (e) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (f) { /* empty */ }
  } return false;
};

// `String.prototype.includes` method
// https://tc39.github.io/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var SPECIES$5 = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };

    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$5] = function () { return re; };
    }

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
    if (sham) hide(RegExp.prototype[SYMBOL], 'sham', true);
  }
};

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classofRaw(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

var max$1 = Math.max;
var min$2 = Math.min;
var floor$1 = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regexpExecAbstract(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max$1(min$2(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor$1(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

// `SameValue` abstract operation
// https://tc39.github.io/ecma262/#sec-samevalue
var sameValue = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

// @@search logic
fixRegexpWellKnownSymbolLogic('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative(nativeSearch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regexpExecAbstract(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/**
 * Slug Function v0.4.0
 * @author hardylin<hardylin@tencent.com>
 */

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule$1(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var O$1 = 'object';
var check$1 = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1$1 =
  // eslint-disable-next-line no-undef
  check$1(typeof globalThis == O$1 && globalThis) ||
  check$1(typeof window == O$1 && window) ||
  check$1(typeof self == O$1 && self) ||
  check$1(typeof commonjsGlobal$1 == O$1 && commonjsGlobal$1) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

var fails$1 = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var descriptors$1 = !fails$1(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var isObject$1 = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var document$1$1 = global_1$1.document;
// typeof document.createElement is 'object' in old IE
var exist = isObject$1(document$1$1) && isObject$1(document$1$1.createElement);

var documentCreateElement$1 = function (it) {
  return exist ? document$1$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine$1 = !descriptors$1 && !fails$1(function () {
  return Object.defineProperty(documentCreateElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var anObject$1 = function (it) {
  if (!isObject$1(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

// 7.1.1 ToPrimitive(input [, PreferredType])
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$1 = function (it, S) {
  if (!isObject$1(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject$1(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject$1(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject$1(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var nativeDefineProperty$1 = Object.defineProperty;

var f$6 = descriptors$1 ? nativeDefineProperty$1 : function defineProperty(O, P, Attributes) {
  anObject$1(O);
  P = toPrimitive$1(P, true);
  anObject$1(Attributes);
  if (ie8DomDefine$1) try {
    return nativeDefineProperty$1(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty$1 = {
	f: f$6
};

var createPropertyDescriptor$1 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var hide$1 = descriptors$1 ? function (object, key, value) {
  return objectDefineProperty$1.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var setGlobal$1 = function (key, value) {
  try {
    hide$1(global_1$1, key, value);
  } catch (error) {
    global_1$1[key] = value;
  } return value;
};

var isPure$1 = false;

var shared$1 = createCommonjsModule$1(function (module) {
var SHARED = '__core-js_shared__';
var store = global_1$1[SHARED] || setGlobal$1(SHARED, {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.1.3',
  mode: 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});
});

var hasOwnProperty$1 = {}.hasOwnProperty;

var has$2 = function (it, key) {
  return hasOwnProperty$1.call(it, key);
};

var functionToString$1 = shared$1('native-function-to-string', Function.toString);

var WeakMap$2 = global_1$1.WeakMap;

var nativeWeakMap$1 = typeof WeakMap$2 === 'function' && /native code/.test(functionToString$1.call(WeakMap$2));

var id$1 = 0;
var postfix$1 = Math.random();

var uid$1 = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id$1 + postfix$1).toString(36));
};

var keys$1 = shared$1('keys');

var sharedKey$1 = function (key) {
  return keys$1[key] || (keys$1[key] = uid$1(key));
};

var hiddenKeys$2 = {};

var WeakMap$1$1 = global_1$1.WeakMap;
var set$2, get$1, has$1$1;

var enforce$1 = function (it) {
  return has$1$1(it) ? get$1(it) : set$2(it, {});
};

var getterFor$1 = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$1(it) || (state = get$1(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap$1) {
  var store$2 = new WeakMap$1$1();
  var wmget$1 = store$2.get;
  var wmhas$1 = store$2.has;
  var wmset$1 = store$2.set;
  set$2 = function (it, metadata) {
    wmset$1.call(store$2, it, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return wmget$1.call(store$2, it) || {};
  };
  has$1$1 = function (it) {
    return wmhas$1.call(store$2, it);
  };
} else {
  var STATE$1 = sharedKey$1('state');
  hiddenKeys$2[STATE$1] = true;
  set$2 = function (it, metadata) {
    hide$1(it, STATE$1, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return has$2(it, STATE$1) ? it[STATE$1] : {};
  };
  has$1$1 = function (it) {
    return has$2(it, STATE$1);
  };
}

var internalState$1 = {
  set: set$2,
  get: get$1,
  has: has$1$1,
  enforce: enforce$1,
  getterFor: getterFor$1
};

var redefine$1 = createCommonjsModule$1(function (module) {
var getInternalState = internalState$1.get;
var enforceInternalState = internalState$1.enforce;
var TEMPLATE = String(functionToString$1).split('toString');

shared$1('inspectSource', function (it) {
  return functionToString$1.call(it);
});

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$2(value, 'name')) hide$1(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global_1$1) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else hide$1(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || functionToString$1.call(this);
});
});

var toString$1 = {}.toString;

var classofRaw$1 = function (it) {
  return toString$1.call(it).slice(8, -1);
};

var nativeSymbol$1 = !!Object.getOwnPropertySymbols && !fails$1(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});

var Symbol$1$1 = global_1$1.Symbol;
var store$1$1 = shared$1('wks');

var wellKnownSymbol$1 = function (name) {
  return store$1$1[name] || (store$1$1[name] = nativeSymbol$1 && Symbol$1$1[name]
    || (nativeSymbol$1 ? Symbol$1$1 : uid$1)('Symbol.' + name));
};

var TO_STRING_TAG$3 = wellKnownSymbol$1('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS$1 = classofRaw$1(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet$1 = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$1 = function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet$1(O = Object(it), TO_STRING_TAG$3)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS$1 ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

var TO_STRING_TAG$1$1 = wellKnownSymbol$1('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$1$1] = 'z';

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
var objectToString$1 = String(test$1) !== '[object z]' ? function toString() {
  return '[object ' + classof$1(this) + ']';
} : test$1.toString;

var ObjectPrototype$1 = Object.prototype;

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (objectToString$1 !== ObjectPrototype$1.toString) {
  redefine$1(ObjectPrototype$1, 'toString', objectToString$1, { unsafe: true });
}

var nativePropertyIsEnumerable$1 = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG$1 = getOwnPropertyDescriptor$3 && !nativePropertyIsEnumerable$1.call({ 1: 2 }, 1);

var f$1$1 = NASHORN_BUG$1 ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable$1;

var objectPropertyIsEnumerable$1 = {
	f: f$1$1
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings



var split$1 = ''.split;

var indexedObject$1 = fails$1(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw$1(it) == 'String' ? split$1.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$1 = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject$1 = function (it) {
  return indexedObject$1(requireObjectCoercible$1(it));
};

var nativeGetOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

var f$2$1 = descriptors$1 ? nativeGetOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$1(O);
  P = toPrimitive$1(P, true);
  if (ie8DomDefine$1) try {
    return nativeGetOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (has$2(O, P)) return createPropertyDescriptor$1(!objectPropertyIsEnumerable$1.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor$1 = {
	f: f$2$1
};

var ceil$1 = Math.ceil;
var floor$2 = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger$1 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor$2 : ceil$1)(argument);
};

var min$3 = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength$1 = function (argument) {
  return argument > 0 ? min$3(toInteger$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max$2 = Math.max;
var min$1$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toInteger$1(index);
  return integer < 0 ? max$2(integer + length, 0) : min$1$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
// false -> Array#indexOf
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
// true  -> Array#includes
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
var arrayIncludes$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$1($this);
    var length = toLength$1(O.length);
    var index = toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIndexOf = arrayIncludes$1(false);

var objectKeysInternal$1 = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$2(hiddenKeys$2, key) && has$2(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$2(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$1 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)



var hiddenKeys$1$1 = enumBugKeys$1.concat('length', 'prototype');

var f$3$1 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal$1(O, hiddenKeys$1$1);
};

var objectGetOwnPropertyNames$1 = {
	f: f$3$1
};

var f$4$1 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols$1 = {
	f: f$4$1
};

var Reflect = global_1$1.Reflect;

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames$1.f(anObject$1(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols$1.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties$1 = function (target, source) {
  var keys = ownKeys$1(source);
  var defineProperty = objectDefineProperty$1.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor$1.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has$2(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement$1 = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data$1[normalize$1(feature)];
  return value == POLYFILL$1 ? true
    : value == NATIVE$1 ? false
    : typeof detection == 'function' ? fails$1(detection)
    : !!detection;
};

var normalize$1 = isForced$1.normalize = function (string) {
  return String(string).replace(replacement$1, '.').toLowerCase();
};

var data$1 = isForced$1.data = {};
var NATIVE$1 = isForced$1.NATIVE = 'N';
var POLYFILL$1 = isForced$1.POLYFILL = 'P';

var isForced_1$1 = isForced$1;

var getOwnPropertyDescriptor$1$1 = objectGetOwnPropertyDescriptor$1.f;






/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export$1 = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1$1;
  } else if (STATIC) {
    target = global_1$1[TARGET] || setGlobal$1(TARGET, {});
  } else {
    target = (global_1$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      hide$1(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$1(target, key, sourceProperty, options);
  }
};

var path$1 = global_1$1;

var redefineAll$1 = function (target, src, options) {
  for (var key in src) redefine$1(target, key, src[key], options);
  return target;
};

var defineProperty$1 = objectDefineProperty$1.f;



var TO_STRING_TAG$2$1 = wellKnownSymbol$1('toStringTag');

var setToStringTag$1 = function (it, TAG, STATIC) {
  if (it && !has$2(it = STATIC ? it : it.prototype, TO_STRING_TAG$2$1)) {
    defineProperty$1(it, TO_STRING_TAG$2$1, { configurable: true, value: TAG });
  }
};

var aFunction$2 = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$1 = function (namespace, method) {
  return arguments.length < 2 ? aFunction$2(path$1[namespace]) || aFunction$2(global_1$1[namespace])
    : path$1[namespace] && path$1[namespace][method] || global_1$1[namespace] && global_1$1[namespace][method];
};

var SPECIES$6 = wellKnownSymbol$1('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var C = getBuiltIn$1(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty$1.f;
  if (descriptors$1 && C && !C[SPECIES$6]) defineProperty(C, SPECIES$6, {
    configurable: true,
    get: function () { return this; }
  });
};

var aFunction$1$1 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

var anInstance$1 = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};

var iterators$1 = {};

var ITERATOR$3 = wellKnownSymbol$1('iterator');
var ArrayPrototype$2 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (iterators$1.Array === it || ArrayPrototype$2[ITERATOR$3] === it);
};

// optional / simple context binding
var bindContext$1 = function (fn, that, length) {
  aFunction$1$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var ITERATOR$1$1 = wellKnownSymbol$1('iterator');

var getIteratorMethod$1 = function (it) {
  if (it != undefined) return it[ITERATOR$1$1]
    || it['@@iterator']
    || iterators$1[classof$1(it)];
};

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$1(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject$1(returnMethod.call(iterator));
    throw error;
  }
};

var iterate = createCommonjsModule$1(function (module) {
var BREAK = {};

var exports = module.exports = function (iterable, fn, that, ENTRIES, ITERATOR) {
  var boundFunction = bindContext$1(fn, that, ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, step;

  if (ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod$1(iterFn)) {
      for (index = 0, length = toLength$1(iterable.length); length > index; index++) {
        result = ENTRIES ? boundFunction(anObject$1(step = iterable[index])[0], step[1]) : boundFunction(iterable[index]);
        if (result === BREAK) return BREAK;
      } return;
    }
    iterator = iterFn.call(iterable);
  }

  while (!(step = iterator.next()).done) {
    if (callWithSafeIterationClosing$1(iterator, boundFunction, step.value, ENTRIES) === BREAK) return BREAK;
  }
};

exports.BREAK = BREAK;
});

var ITERATOR$2$1 = wellKnownSymbol$1('iterator');
var SAFE_CLOSING$1 = false;

try {
  var called$1 = 0;
  var iteratorWithReturn$1 = {
    next: function () {
      return { done: !!called$1++ };
    },
    'return': function () {
      SAFE_CLOSING$1 = true;
    }
  };
  iteratorWithReturn$1[ITERATOR$2$1] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn$1, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING$1) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2$1] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var SPECIES$1$1 = wellKnownSymbol$1('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$1(O).constructor;
  var S;
  return C === undefined || (S = anObject$1(C)[SPECIES$1$1]) == undefined ? defaultConstructor : aFunction$1$1(S);
};

var document$2$1 = global_1$1.document;

var html$1 = document$2$1 && document$2$1.documentElement;

var location$1$1 = global_1$1.location;
var set$1$1 = global_1$1.setImmediate;
var clear$1 = global_1$1.clearImmediate;
var process$4 = global_1$1.process;
var MessageChannel$1 = global_1$1.MessageChannel;
var Dispatch$1 = global_1$1.Dispatch;
var counter$1 = 0;
var queue$1 = {};
var ONREADYSTATECHANGE$1 = 'onreadystatechange';
var defer$1, channel$1, port$1;

var run$1 = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue$1.hasOwnProperty(id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner$1 = function (id) {
  return function () {
    run$1(id);
  };
};

var listener$1 = function (event) {
  run$1(event.data);
};

var post$1 = function (id) {
  // old engines have not location.origin
  global_1$1.postMessage(id + '', location$1$1.protocol + '//' + location$1$1.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1$1 || !clear$1) {
  set$1$1 = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue$1[++counter$1] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer$1(counter$1);
    return counter$1;
  };
  clear$1 = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (classofRaw$1(process$4) == 'process') {
    defer$1 = function (id) {
      process$4.nextTick(runner$1(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch$1 && Dispatch$1.now) {
    defer$1 = function (id) {
      Dispatch$1.now(runner$1(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel$1) {
    channel$1 = new MessageChannel$1();
    port$1 = channel$1.port2;
    channel$1.port1.onmessage = listener$1;
    defer$1 = bindContext$1(port$1.postMessage, port$1, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global_1$1.addEventListener && typeof postMessage == 'function' && !global_1$1.importScripts && !fails$1(post$1)) {
    defer$1 = post$1;
    global_1$1.addEventListener('message', listener$1, false);
  // IE8-
  } else if (ONREADYSTATECHANGE$1 in documentCreateElement$1('script')) {
    defer$1 = function (id) {
      html$1.appendChild(documentCreateElement$1('script'))[ONREADYSTATECHANGE$1] = function () {
        html$1.removeChild(this);
        run$1(id);
      };
    };
  // Rest old browsers
  } else {
    defer$1 = function (id) {
      setTimeout(runner$1(id), 0);
    };
  }
}

var task$2 = {
  set: set$1$1,
  clear: clear$1
};

var navigator$1 = global_1$1.navigator;

var userAgent$1 = navigator$1 && navigator$1.userAgent || '';

var getOwnPropertyDescriptor$2$1 = objectGetOwnPropertyDescriptor$1.f;

var macrotask$1 = task$2.set;


var MutationObserver$1 = global_1$1.MutationObserver || global_1$1.WebKitMutationObserver;
var process$1$1 = global_1$1.process;
var Promise$1$1 = global_1$1.Promise;
var IS_NODE$2 = classofRaw$1(process$1$1) == 'process';
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor$1 = getOwnPropertyDescriptor$2$1(global_1$1, 'queueMicrotask');
var queueMicrotask$1 = queueMicrotaskDescriptor$1 && queueMicrotaskDescriptor$1.value;

var flush$1, head$1, last$1, notify$2, toggle$1, node$1, promise$1;

// modern engines have queueMicrotask method
if (!queueMicrotask$1) {
  flush$1 = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1$1.domain)) parent.exit();
    while (head$1) {
      fn = head$1.fn;
      head$1 = head$1.next;
      try {
        fn();
      } catch (error) {
        if (head$1) notify$2();
        else last$1 = undefined;
        throw error;
      }
    } last$1 = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE$2) {
    notify$2 = function () {
      process$1$1.nextTick(flush$1);
    };
  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver$1 && !/(iphone|ipod|ipad).*applewebkit/i.test(userAgent$1)) {
    toggle$1 = true;
    node$1 = document.createTextNode('');
    new MutationObserver$1(flush$1).observe(node$1, { characterData: true }); // eslint-disable-line no-new
    notify$2 = function () {
      node$1.data = toggle$1 = !toggle$1;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1$1 && Promise$1$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise$1 = Promise$1$1.resolve(undefined);
    notify$2 = function () {
      promise$1.then(flush$1);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify$2 = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask$1.call(global_1$1, flush$1);
    };
  }
}

var microtask$1 = queueMicrotask$1 || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last$1) last$1.next = task;
  if (!head$1) {
    head$1 = task;
    notify$2();
  } last$1 = task;
};

var PromiseCapability$1 = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction$1$1(resolve);
  this.reject = aFunction$1$1(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
var f$5$1 = function (C) {
  return new PromiseCapability$1(C);
};

var newPromiseCapability$2 = {
	f: f$5$1
};

var promiseResolve$1 = function (C, x) {
  anObject$1(C);
  if (isObject$1(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$2.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var hostReportErrors$1 = function (a, b) {
  var console = global_1$1.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var task$1$1 = task$2.set;










var SPECIES$2$1 = wellKnownSymbol$1('species');
var PROMISE$1 = 'Promise';
var getInternalState$1 = internalState$1.get;
var setInternalState$1 = internalState$1.set;
var getInternalPromiseState$1 = internalState$1.getterFor(PROMISE$1);
var PromiseConstructor$1 = global_1$1[PROMISE$1];
var TypeError$1$1 = global_1$1.TypeError;
var document$3 = global_1$1.document;
var process$2$1 = global_1$1.process;
var $fetch$1 = global_1$1.fetch;
var versions$1 = process$2$1 && process$2$1.versions;
var v8$1 = versions$1 && versions$1.v8 || '';
var newPromiseCapability$1$1 = newPromiseCapability$2.f;
var newGenericPromiseCapability$1 = newPromiseCapability$1$1;
var IS_NODE$1$1 = classofRaw$1(process$2$1) == 'process';
var DISPATCH_EVENT$1 = !!(document$3 && document$3.createEvent && global_1$1.dispatchEvent);
var UNHANDLED_REJECTION$1 = 'unhandledrejection';
var REJECTION_HANDLED$1 = 'rejectionhandled';
var PENDING$1 = 0;
var FULFILLED$1 = 1;
var REJECTED$1 = 2;
var HANDLED$1 = 1;
var UNHANDLED$1 = 2;
var Internal$1, OwnPromiseCapability$1, PromiseWrapper$1;

var FORCED$2 = isForced_1$1(PROMISE$1, function () {
  // correct subclassing with @@species support
  var promise = PromiseConstructor$1.resolve(1);
  var empty = function () { /* empty */ };
  var FakePromise = (promise.constructor = {})[SPECIES$2$1] = function (exec) {
    exec(empty, empty);
  };
  // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !((IS_NODE$1$1 || typeof PromiseRejectionEvent == 'function')
    && (!isPure$1 || promise['finally'])
    && promise.then(empty) instanceof FakePromise
    // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // we can't detect it synchronously, so just check versions
    && v8$1.indexOf('6.6') !== 0
    && userAgent$1.indexOf('Chrome/66') === -1);
});

var INCORRECT_ITERATION$1 = FORCED$2 || !checkCorrectnessOfIteration$1(function (iterable) {
  PromiseConstructor$1.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable$1 = function (it) {
  var then;
  return isObject$1(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify$1$1 = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask$1(function () {
    var value = state.value;
    var ok = state.state == FULFILLED$1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED$1) onHandleUnhandled$1(promise, state);
            state.rejection = HANDLED$1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1$1('Promise-chain cycle'));
          } else if (then = isThenable$1(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled$1(promise, state);
  });
};

var dispatchEvent$1 = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT$1) {
    event = document$3.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1$1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (handler = global_1$1['on' + name]) handler(event);
  else if (name === UNHANDLED_REJECTION$1) hostReportErrors$1('Unhandled promise rejection', reason);
};

var onUnhandled$1 = function (promise, state) {
  task$1$1.call(global_1$1, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled$1(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$1(function () {
        if (IS_NODE$1$1) {
          process$2$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent$1(UNHANDLED_REJECTION$1, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1$1 || isUnhandled$1(state) ? UNHANDLED$1 : HANDLED$1;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled$1 = function (state) {
  return state.rejection !== HANDLED$1 && !state.parent;
};

var onHandleUnhandled$1 = function (promise, state) {
  task$1$1.call(global_1$1, function () {
    if (IS_NODE$1$1) {
      process$2$1.emit('rejectionHandled', promise);
    } else dispatchEvent$1(REJECTION_HANDLED$1, promise, state.value);
  });
};

var bind$1 = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject$1 = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED$1;
  notify$1$1(promise, state, true);
};

var internalResolve$1 = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError$1$1("Promise can't be resolved itself");
    var then = isThenable$1(value);
    if (then) {
      microtask$1(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind$1(internalResolve$1, promise, wrapper, state),
            bind$1(internalReject$1, promise, wrapper, state)
          );
        } catch (error) {
          internalReject$1(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED$1;
      notify$1$1(promise, state, false);
    }
  } catch (error) {
    internalReject$1(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED$2) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor$1 = function Promise(executor) {
    anInstance$1(this, PromiseConstructor$1, PROMISE$1);
    aFunction$1$1(executor);
    Internal$1.call(this);
    var state = getInternalState$1(this);
    try {
      executor(bind$1(internalResolve$1, this, state), bind$1(internalReject$1, this, state));
    } catch (error) {
      internalReject$1(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal$1 = function Promise(executor) {
    setInternalState$1(this, {
      type: PROMISE$1,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING$1,
      value: undefined
    });
  };
  Internal$1.prototype = redefineAll$1(PromiseConstructor$1.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState$1(this);
      var reaction = newPromiseCapability$1$1(speciesConstructor$1(this, PromiseConstructor$1));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE$1$1 ? process$2$1.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING$1) notify$1$1(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability$1 = function () {
    var promise = new Internal$1();
    var state = getInternalState$1(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve$1, promise, state);
    this.reject = bind$1(internalReject$1, promise, state);
  };
  newPromiseCapability$2.f = newPromiseCapability$1$1 = function (C) {
    return C === PromiseConstructor$1 || C === PromiseWrapper$1
      ? new OwnPromiseCapability$1(C)
      : newGenericPromiseCapability$1(C);
  };

  // wrap fetch result
  if (typeof $fetch$1 == 'function') _export$1({ global: true, enumerable: true, forced: true }, {
    // eslint-disable-next-line no-unused-vars
    fetch: function fetch(input) {
      return promiseResolve$1(PromiseConstructor$1, $fetch$1.apply(global_1$1, arguments));
    }
  });
}

_export$1({ global: true, wrap: true, forced: FORCED$2 }, {
  Promise: PromiseConstructor$1
});

setToStringTag$1(PromiseConstructor$1, PROMISE$1, false);
setSpecies$1(PROMISE$1);

PromiseWrapper$1 = path$1[PROMISE$1];

// statics
_export$1({ target: PROMISE$1, stat: true, forced: FORCED$2 }, {
  // `Promise.reject` method
  // https://tc39.github.io/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability$1$1(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

_export$1({ target: PROMISE$1, stat: true, forced: FORCED$2 }, {
  // `Promise.resolve` method
  // https://tc39.github.io/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve$1(this, x);
  }
});

_export$1({ target: PROMISE$1, stat: true, forced: INCORRECT_ITERATION$1 }, {
  // `Promise.all` method
  // https://tc39.github.io/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability$1$1(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aFunction$1$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.github.io/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability$1$1(C);
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aFunction$1$1(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$1(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var nativeExec$1 = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace$1 = String.prototype.replace;

var patchedExec$1 = nativeExec$1;

var UPDATES_LAST_INDEX_WRONG$1 = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec$1.call(re1, 'a');
  nativeExec$1.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED$1 = /()??/.exec('')[1] !== undefined;

var PATCH$1 = UPDATES_LAST_INDEX_WRONG$1 || NPCG_INCLUDED$1;

if (PATCH$1) {
  patchedExec$1 = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED$1) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags$1.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG$1) lastIndex = re.lastIndex;

    match = nativeExec$1.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG$1 && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED$1 && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace$1.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec$1 = patchedExec$1;

var SPECIES$3$1 = wellKnownSymbol$1('species');

var REPLACE_SUPPORTS_NAMED_GROUPS$1 = !fails$1(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC$1 = !fails$1(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var fixRegexpWellKnownSymbolLogic$1 = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol$1(KEY);

  var DELEGATES_TO_SYMBOL = !fails$1(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$1(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };

    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$3$1] = function () { return re; };
    }

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS$1) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC$1)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec$1) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine$1(String.prototype, KEY, stringMethod);
    redefine$1(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
    if (sham) hide$1(RegExp.prototype[SYMBOL], 'sham', true);
  }
};

// CONVERT_TO_STRING: true  -> String#at
// CONVERT_TO_STRING: false -> String#codePointAt
var stringAt = function (that, pos, CONVERT_TO_STRING) {
  var S = String(requireObjectCoercible$1(that));
  var position = toInteger$1(pos);
  var size = S.length;
  var first, second;
  if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
  first = S.charCodeAt(position);
  return first < 0xD800 || first > 0xDBFF || position + 1 === size
    || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
      ? CONVERT_TO_STRING ? S.charAt(position) : first
      : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
};

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? stringAt(S, index, true).length : 1);
};

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var regexpExecAbstract$1 = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classofRaw$1(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec$1.call(R, S);
};

// @@match logic
fixRegexpWellKnownSymbolLogic$1('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible$1(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject$1(regexp);
      var S = String(this);

      if (!rx.global) return regexpExecAbstract$1(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regexpExecAbstract$1(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$1(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
var isArray$1 = Array.isArray || function isArray(arg) {
  return classofRaw$1(arg) == 'Array';
};

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject$1 = function (argument) {
  return Object(requireObjectCoercible$1(argument));
};

var createProperty$1 = function (object, key, value) {
  var propertyKey = toPrimitive$1(key);
  if (propertyKey in object) objectDefineProperty$1.f(object, propertyKey, createPropertyDescriptor$1(0, value));
  else object[propertyKey] = value;
};

var SPECIES$4$1 = wellKnownSymbol$1('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  var C;
  if (isArray$1(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray$1(C.prototype))) C = undefined;
    else if (isObject$1(C)) {
      C = C[SPECIES$4$1];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var SPECIES$5$1 = wellKnownSymbol$1('species');

var arrayMethodHasSpeciesSupport$1 = function (METHOD_NAME) {
  return !fails$1(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$5$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var IS_CONCAT_SPREADABLE$1 = wellKnownSymbol$1('isConcatSpreadable');
var MAX_SAFE_INTEGER$1 = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED$1 = 'Maximum allowed index exceeded';

var IS_CONCAT_SPREADABLE_SUPPORT$1 = !fails$1(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE$1] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$1('concat');

var isConcatSpreadable$1 = function (O) {
  if (!isObject$1(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE$1];
  return spreadable !== undefined ? !!spreadable : isArray$1(O);
};

var FORCED$1$1 = !IS_CONCAT_SPREADABLE_SUPPORT$1 || !SPECIES_SUPPORT$1;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
_export$1({ target: 'Array', proto: true, forced: FORCED$1$1 }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject$1(this);
    var A = arraySpeciesCreate$1(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable$1(E)) {
        len = toLength$1(E.length);
        if (n + len > MAX_SAFE_INTEGER$1) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED$1);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty$1(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER$1) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED$1);
        createProperty$1(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var objectKeys$1 = Object.keys || function keys(O) {
  return objectKeysInternal$1(O, enumBugKeys$1);
};

var propertyIsEnumerable = objectPropertyIsEnumerable$1.f;

// TO_ENTRIES: true  -> Object.entries
// TO_ENTRIES: false -> Object.values
var objectToArray = function (it, TO_ENTRIES) {
  var O = toIndexedObject$1(it);
  var keys = objectKeys$1(O);
  var length = keys.length;
  var i = 0;
  var result = [];
  var key;
  while (length > i) {
    key = keys[i++];
    if (!descriptors$1 || propertyIsEnumerable.call(O, key)) {
      result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
    }
  }
  return result;
};

// `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries
_export$1({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return objectToArray(O, true);
  }
});

var max$1$1 = Math.max;
var min$2$1 = Math.min;
var floor$1$1 = Math.floor;
var SUBSTITUTION_SYMBOLS$1 = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED$1 = /\$([$&'`]|\d\d?)/g;

var maybeToString$1 = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegexpWellKnownSymbolLogic$1('replace', 2, function (REPLACE, nativeReplace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$1(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject$1(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regexpExecAbstract$1(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$1(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max$1$1(min$2$1(toInteger$1(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString$1(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED$1;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject$1(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS$1;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor$1$1(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
// 0 -> Array#forEach
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
// 1 -> Array#map
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// 2 -> Array#filter
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// 3 -> Array#some
// https://tc39.github.io/ecma262/#sec-array.prototype.some
// 4 -> Array#every
// https://tc39.github.io/ecma262/#sec-array.prototype.every
// 5 -> Array#find
// https://tc39.github.io/ecma262/#sec-array.prototype.find
// 6 -> Array#findIndex
// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
var arrayMethods = function (TYPE, specificCreate) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = specificCreate || arraySpeciesCreate$1;
  return function ($this, callbackfn, that) {
    var O = toObject$1($this);
    var self = indexedObject$1(O);
    var boundFunction = bindContext$1(callbackfn, that, 3);
    var length = toLength$1(self.length);
    var index = 0;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: target.push(value);       // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var sloppyArrayMethod = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !method || !fails$1(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var internalForEach = arrayMethods(0);
var SLOPPY_METHOD = sloppyArrayMethod('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
var arrayForEach = SLOPPY_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return internalForEach(this, callbackfn, arguments[1]);
} : [].forEach;

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1$1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
    hide$1(CollectionPrototype, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach;
  }
}

/**
 * @file 对象
 * @author hardylin <hardylin@tencent.com>
 */

/**
 * 参数序列化
 * @param {Object} params - 参数对象
 * @returns {String} - 序列化后的参数字符串
 */
function stringify(params) {
  var str = '';
  Object.entries(params).forEach(function (item) {
    str += "&".concat(item[0], "=").concat(encodeURIComponent(item[1]));
  });
  return str.replace(/^&/, '');
}

var internalIndexOf = arrayIncludes$1(false);
var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var SLOPPY_METHOD$1 = sloppyArrayMethod('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
_export$1({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || SLOPPY_METHOD$1 }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : internalIndexOf(this, searchElement, arguments[1]);
  }
});

var validateSetPrototypeOfArguments = function (O, proto) {
  anObject$1(O);
  if (!isObject$1(proto) && proto !== null) {
    throw TypeError("Can't set " + String(proto) + ' as a prototype');
  }
};

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var correctSetter = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    correctSetter = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    validateSetPrototypeOfArguments(O, proto);
    if (correctSetter) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var inheritIfRequired = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject$1(P) && objectSetPrototypeOf) {
    objectSetPrototypeOf(that, P);
  } return that;
};

var objectDefineProperties$1 = descriptors$1 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$1(O);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var i = 0;
  var key;
  while (length > i) objectDefineProperty$1.f(O, key = keys[i++], Properties[key]);
  return O;
};

var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var PROTOTYPE$1 = 'prototype';
var Empty$1 = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict$1 = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var length = enumBugKeys$1.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict$1 = iframeDocument.F;
  while (length--) delete createDict$1[PROTOTYPE$1][enumBugKeys$1[length]];
  return createDict$1();
};

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var objectCreate$1 = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty$1[PROTOTYPE$1] = anObject$1(O);
    result = new Empty$1();
    Empty$1[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict$1();
  return Properties === undefined ? result : objectDefineProperties$1(result, Properties);
};

hiddenKeys$2[IE_PROTO$1] = true;

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// 1 -> String#trimStart
// 2 -> String#trimEnd
// 3 -> String#trim
var stringTrim = function (string, TYPE) {
  string = String(requireObjectCoercible$1(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

var getOwnPropertyNames = objectGetOwnPropertyNames$1.f;
var getOwnPropertyDescriptor$3$1 = objectGetOwnPropertyDescriptor$1.f;
var defineProperty$1$1 = objectDefineProperty$1.f;


var NUMBER = 'Number';
var NativeNumber = global_1$1[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classofRaw$1(objectCreate$1(NumberPrototype)) == NUMBER;
var NATIVE_TRIM = 'trim' in String.prototype;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive$1(argument, false);
  var first, third, radix, maxCode, digits, length, i, code;
  if (typeof it == 'string' && it.length > 2) {
    it = NATIVE_TRIM ? it.trim() : stringTrim(it, 3);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (i = 0; i < length; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced_1$1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails$1(function () { NumberPrototype.valueOf.call(that); }) : classofRaw$1(that) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), that, NumberWrapper) : toNumber(it);
  };
  for (var keys$1$1 = descriptors$1 ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys$1$1.length > j; j++) {
    if (has$2(NativeNumber, key = keys$1$1[j]) && !has$2(NumberWrapper, key)) {
      defineProperty$1$1(NumberWrapper, key, getOwnPropertyDescriptor$3$1(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine$1(global_1$1, NUMBER, NumberWrapper);
}

var nativeParseInt = global_1$1.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED$2$1 = nativeParseInt(whitespaces + '08') !== 8 || nativeParseInt(whitespaces + '0x16') !== 22;

var _parseInt = FORCED$2$1 ? function parseInt(str, radix) {
  var string = stringTrim(String(str), 3);
  return nativeParseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : nativeParseInt;

// `Number.parseInt` method
// https://tc39.github.io/ecma262/#sec-number.parseint
_export$1({ target: 'Number', stat: true, forced: Number.parseInt != _parseInt }, {
  parseInt: _parseInt
});

/**
 * jsonp 请求
 * @param {Object} options - 参数对象
 * @param {String} options.url - 请求 URL
 * @param {Object} options.data - 请求参数
 * @param {Number} [options.timeout=60000] - 请求超时时间
 * @param {String} [name='callback'] - 回调函数参数名
 * @returns {Obejct} Promise 对象
 */

function jsonp(options) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'callback';
  return new Promise(function (resolve, reject) {
    var url = options.url,
        _options$data = options.data,
        data = _options$data === void 0 ? {} : _options$data,
        _options$timeout = options.timeout,
        timeout = _options$timeout === void 0 ? 60000 : _options$timeout;
    /* #region 请求超时 */

    var timer = 0;

    if (timeout) {
      timer = setTimeout(function () {
        cleanup();
        reject(new Error('Timeout'));
      }, timeout);
    }
    /* #endregion */

    /* #region 请求成功 */


    var id = "sfn_".concat(Number.parseInt(Math.random() * 1000000));

    window[id] = function (data) {
      resolve(data);
      cleanup();
    };
    /* #endregion */

    /* #region 参数序列化处理 */


    url += (url.indexOf('?') < 0 ? '?' : '&') + stringify(data) + '&' + name + '=' + id;
    url = url.replace('?&', '?');
    /* #endregion */

    /* #region 创建 script 标签 */

    var script = document.createElement('script');
    script.src = url;
    document.body.appendChild(script);
    /* #endregion */

    function cleanup() {
      delete window[id];
      script.remove();
      clearTimeout(timer);
    }
  });
}

var f$6$1 = wellKnownSymbol$1;

var wrappedWellKnownSymbol = {
	f: f$6$1
};

var defineProperty$2 = objectDefineProperty$1.f;

var defineWellKnownSymbol = function (NAME) {
  var Symbol = path$1.Symbol || (path$1.Symbol = {});
  if (!has$2(Symbol, NAME)) defineProperty$2(Symbol, NAME, {
    value: wrappedWellKnownSymbol.f(NAME)
  });
};

// all enumerable object keys, includes symbols
var enumKeys = function (it) {
  var result = objectKeys$1(it);
  var getOwnPropertySymbols = objectGetOwnPropertySymbols$1.f;
  if (getOwnPropertySymbols) {
    var symbols = getOwnPropertySymbols(it);
    var propertyIsEnumerable = objectPropertyIsEnumerable$1.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (propertyIsEnumerable.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

var nativeGetOwnPropertyNames = objectGetOwnPropertyNames$1.f;

var toString$1$1 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var f$7 = function getOwnPropertyNames(it) {
  return windowNames && toString$1$1.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject$1(it));
};

var objectGetOwnPropertyNamesExternal = {
	f: f$7
};

var HIDDEN = sharedKey$1('hidden');
var SYMBOL = 'Symbol';
var setInternalState$1$1 = internalState$1.set;
var getInternalState$1$1 = internalState$1.getterFor(SYMBOL);
var nativeGetOwnPropertyDescriptor$1$1 = objectGetOwnPropertyDescriptor$1.f;
var nativeDefineProperty$1$1 = objectDefineProperty$1.f;
var nativeGetOwnPropertyNames$1 = objectGetOwnPropertyNamesExternal.f;
var $Symbol = global_1$1.Symbol;
var JSON = global_1$1.JSON;
var nativeJSONStringify = JSON && JSON.stringify;
var PROTOTYPE$1$1 = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol$1('toPrimitive');
var nativePropertyIsEnumerable$1$1 = objectPropertyIsEnumerable$1.f;
var SymbolRegistry = shared$1('symbol-registry');
var AllSymbols = shared$1('symbols');
var ObjectPrototypeSymbols = shared$1('op-symbols');
var WellKnownSymbolsStore = shared$1('wks');
var ObjectPrototype$1$1 = Object[PROTOTYPE$1$1];
var QObject = global_1$1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE$1$1] || !QObject[PROTOTYPE$1$1].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = descriptors$1 && fails$1(function () {
  return objectCreate$1(nativeDefineProperty$1$1({}, 'a', {
    get: function () { return nativeDefineProperty$1$1(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$1$1(ObjectPrototype$1$1, key);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype$1$1[key];
  nativeDefineProperty$1$1(it, key, D);
  if (ObjectPrototypeDescriptor && it !== ObjectPrototype$1$1) {
    nativeDefineProperty$1$1(ObjectPrototype$1$1, key, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty$1$1;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = objectCreate$1($Symbol[PROTOTYPE$1$1]);
  setInternalState$1$1(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!descriptors$1) symbol.description = description;
  return symbol;
};

var isSymbol = nativeSymbol$1 && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectPrototype$1$1) $defineProperty(ObjectPrototypeSymbols, key, D);
  anObject$1(it);
  key = toPrimitive$1(key, true);
  anObject$1(D);
  if (has$2(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has$2(it, HIDDEN)) nativeDefineProperty$1$1(it, HIDDEN, createPropertyDescriptor$1(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has$2(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = objectCreate$1(D, { enumerable: createPropertyDescriptor$1(0, false) });
    } return setSymbolDescriptor(it, key, D);
  } return nativeDefineProperty$1$1(it, key, D);
};

var $defineProperties = function defineProperties(it, P) {
  anObject$1(it);
  var keys = enumKeys(P = toIndexedObject$1(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};

var $create = function create(it, P) {
  return P === undefined ? objectCreate$1(it) : $defineProperties(objectCreate$1(it), P);
};

var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = nativePropertyIsEnumerable$1$1.call(this, key = toPrimitive$1(key, true));
  if (this === ObjectPrototype$1$1 && has$2(AllSymbols, key) && !has$2(ObjectPrototypeSymbols, key)) return false;
  return E || !has$2(this, key) || !has$2(AllSymbols, key) || has$2(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIndexedObject$1(it);
  key = toPrimitive$1(key, true);
  if (it === ObjectPrototype$1$1 && has$2(AllSymbols, key) && !has$2(ObjectPrototypeSymbols, key)) return;
  var D = nativeGetOwnPropertyDescriptor$1$1(it, key);
  if (D && has$2(AllSymbols, key) && !(has$2(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};

var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = nativeGetOwnPropertyNames$1(toIndexedObject$1(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has$2(AllSymbols, key = names[i++]) && !has$2(hiddenKeys$2, key)) result.push(key);
  } return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectPrototype$1$1;
  var names = nativeGetOwnPropertyNames$1(IS_OP ? ObjectPrototypeSymbols : toIndexedObject$1(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has$2(AllSymbols, key = names[i++]) && (IS_OP ? has$2(ObjectPrototype$1$1, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!nativeSymbol$1) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid$1(description);
    var setter = function (value) {
      if (this === ObjectPrototype$1$1) setter.call(ObjectPrototypeSymbols, value);
      if (has$2(this, HIDDEN) && has$2(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor$1(1, value));
    };
    if (descriptors$1 && USE_SETTER) setSymbolDescriptor(ObjectPrototype$1$1, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };
  redefine$1($Symbol[PROTOTYPE$1$1], 'toString', function toString() {
    return getInternalState$1$1(this).tag;
  });

  objectPropertyIsEnumerable$1.f = $propertyIsEnumerable;
  objectDefineProperty$1.f = $defineProperty;
  objectGetOwnPropertyDescriptor$1.f = $getOwnPropertyDescriptor;
  objectGetOwnPropertyNames$1.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  objectGetOwnPropertySymbols$1.f = $getOwnPropertySymbols;

  if (descriptors$1) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty$1$1($Symbol[PROTOTYPE$1$1], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState$1$1(this).description;
      }
    });
    {
      redefine$1(ObjectPrototype$1$1, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }

  wrappedWellKnownSymbol.f = function (name) {
    return wrap(wellKnownSymbol$1(name), name);
  };
}

_export$1({ global: true, wrap: true, forced: !nativeSymbol$1, sham: !nativeSymbol$1 }, {
  Symbol: $Symbol
});

for (var wellKnownSymbols = objectKeys$1(WellKnownSymbolsStore), k = 0; wellKnownSymbols.length > k;) {
  defineWellKnownSymbol(wellKnownSymbols[k++]);
}

_export$1({ target: SYMBOL, stat: true, forced: !nativeSymbol$1 }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    return has$2(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

_export$1({ target: 'Object', stat: true, forced: !nativeSymbol$1, sham: !descriptors$1 }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

_export$1({ target: 'Object', stat: true, forced: !nativeSymbol$1 }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
_export$1({ target: 'Object', stat: true, forced: fails$1(function () { objectGetOwnPropertySymbols$1.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return objectGetOwnPropertySymbols$1.f(toObject$1(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
JSON && _export$1({ target: 'JSON', stat: true, forced: !nativeSymbol$1 || fails$1(function () {
  var symbol = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  return nativeJSONStringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || nativeJSONStringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || nativeJSONStringify(Object(symbol)) != '{}';
}) }, {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject$1(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray$1(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return nativeJSONStringify.apply(JSON, args);
  }
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE$1$1][TO_PRIMITIVE]) hide$1($Symbol[PROTOTYPE$1$1], TO_PRIMITIVE, $Symbol[PROTOTYPE$1$1].valueOf);
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag$1($Symbol, SYMBOL);

hiddenKeys$2[HIDDEN] = true;

var defineProperty$3 = objectDefineProperty$1.f;


var NativeSymbol = global_1$1.Symbol;

if (descriptors$1 && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties$1(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty$3(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject$1(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has$2(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  _export$1({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');

var UNSCOPABLES$1 = wellKnownSymbol$1('unscopables');
var ArrayPrototype$1$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1$1[UNSCOPABLES$1] == undefined) {
  hide$1(ArrayPrototype$1$1, UNSCOPABLES$1, objectCreate$1(null));
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype$1$1[UNSCOPABLES$1][key] = true;
};

var correctPrototypeGetter = !fails$1(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1$1 = sharedKey$1('IE_PROTO');
var ObjectPrototype$2 = Object.prototype;

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (O) {
  O = toObject$1(O);
  if (has$2(O, IE_PROTO$1$1)) return O[IE_PROTO$1$1];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype$2 : null;
};

var ITERATOR$3$1 = wellKnownSymbol$1('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!has$2(IteratorPrototype, ITERATOR$3$1)) hide$1(IteratorPrototype, ITERATOR$3$1, returnThis);

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;





var returnThis$1 = function () { return this; };

var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate$1(IteratorPrototype$1, { next: createPropertyDescriptor$1(1, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  iterators$1[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol$1('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis$2 = function () { return this; };

var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
      if (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$4] != 'function') {
          hide$1(CurrentIteratorPrototype, ITERATOR$4, returnThis$2);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    hide$1(IterablePrototype, ITERATOR$4, defaultIterator);
  }
  iterators$1[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$1(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export$1({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$2 = internalState$1.set;
var getInternalState$2 = internalState$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$2(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$1(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$2(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
iterators$1.Arguments = iterators$1.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// `String.prototype.codePointAt` method
// https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
_export$1({ target: 'String', proto: true }, {
  codePointAt: function codePointAt(pos) {
    return stringAt(this, pos);
  }
});

var fromCharCode = String.fromCharCode;
var nativeFromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!nativeFromCodePoint && nativeFromCodePoint.length != 1;

// `String.fromCodePoint` method
// https://tc39.github.io/ecma262/#sec-string.fromcodepoint
_export$1({ target: 'String', stat: true, forced: INCORRECT_LENGTH }, {
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex$1(code, 0x10FFFF) !== code) throw RangeError(code + ' is not a valid code point');
      elements.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00)
      );
    } return elements.join('');
  }
});

var STRING_ITERATOR = 'String Iterator';
var setInternalState$3 = internalState$1.set;
var getInternalState$3 = internalState$1.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$3(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$3(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = stringAt(string, index, true);
  state.index += point.length;
  return { value: point, done: false };
});

var ITERATOR$5 = wellKnownSymbol$1('iterator');
var TO_STRING_TAG$3$1 = wellKnownSymbol$1('toStringTag');
var ArrayValues = es_array_iterator.values;

for (var COLLECTION_NAME$1 in domIterables) {
  var Collection$1 = global_1$1[COLLECTION_NAME$1];
  var CollectionPrototype$1 = Collection$1 && Collection$1.prototype;
  if (CollectionPrototype$1) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype$1[ITERATOR$5] !== ArrayValues) try {
      hide$1(CollectionPrototype$1, ITERATOR$5, ArrayValues);
    } catch (error) {
      CollectionPrototype$1[ITERATOR$5] = ArrayValues;
    }
    if (!CollectionPrototype$1[TO_STRING_TAG$3$1]) hide$1(CollectionPrototype$1, TO_STRING_TAG$3$1, COLLECTION_NAME$1);
    if (domIterables[COLLECTION_NAME$1]) for (var METHOD_NAME in es_array_iterator) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype$1[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
        hide$1(CollectionPrototype$1, METHOD_NAME, es_array_iterator[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype$1[METHOD_NAME] = es_array_iterator[METHOD_NAME];
      }
    }
  }
}

var SPECIES$6$1 = wellKnownSymbol$1('species');
var nativeSlice = [].slice;
var max$2$1 = Math.max;

var SPECIES_SUPPORT$1$1 = arrayMethodHasSpeciesSupport$1('slice');

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export$1({ target: 'Array', proto: true, forced: !SPECIES_SUPPORT$1$1 }, {
  slice: function slice(start, end) {
    var O = toIndexedObject$1(this);
    var length = toLength$1(O.length);
    var k = toAbsoluteIndex$1(start, length);
    var fin = toAbsoluteIndex$1(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray$1(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray$1(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject$1(Constructor)) {
        Constructor = Constructor[SPECIES$6$1];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max$2$1(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty$1(result, n, O[k]);
    result.length = n;
    return result;
  }
});

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
_export$1({ global: true, forced: parseInt != _parseInt }, {
  parseInt: _parseInt
});

var MATCH$2 = wellKnownSymbol$1('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp$1 = function (it) {
  var isRegExp;
  return isObject$1(it) && ((isRegExp = it[MATCH$2]) !== undefined ? !!isRegExp : classofRaw$1(it) == 'RegExp');
};

var defineProperty$4 = objectDefineProperty$1.f;
var getOwnPropertyNames$1 = objectGetOwnPropertyNames$1.f;







var MATCH$1$1 = wellKnownSymbol$1('match');
var NativeRegExp = global_1$1.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var FORCED$3 = isForced_1$1('RegExp', descriptors$1 && (!CORRECT_NEW || fails$1(function () {
  re2[MATCH$1$1] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.github.io/ecma262/#sec-regexp-constructor
if (FORCED$3) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegexp$1(pattern);
    var flagsAreUndefined = flags === undefined;
    return !thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper && flagsAreUndefined ? pattern
      : inheritIfRequired(CORRECT_NEW
        ? new NativeRegExp(patternIsRegExp && !flagsAreUndefined ? pattern.source : pattern, flags)
        : NativeRegExp((patternIsRegExp = pattern instanceof RegExpWrapper)
          ? pattern.source
          : pattern, patternIsRegExp && flagsAreUndefined ? regexpFlags$1.call(pattern) : flags)
      , thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);
  };
  var proxy = function (key) {
    key in RegExpWrapper || defineProperty$4(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };
  var keys$2 = getOwnPropertyNames$1(NativeRegExp);
  var i = 0;
  while (i < keys$2.length) proxy(keys$2[i++]);
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine$1(global_1$1, 'RegExp', RegExpWrapper);
}

// https://tc39.github.io/ecma262/#sec-get-regexp-@@species
setSpecies$1('RegExp');

var TO_STRING = 'toString';
var nativeToString = /./[TO_STRING];
var RegExpPrototype$1 = RegExp.prototype;

var NOT_GENERIC = fails$1(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine$1(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$1(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype$1) ? regexpFlags$1.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

// `String.prototype.repeat` method implementation
// https://tc39.github.io/ecma262/#sec-string.prototype.repeat
var stringRepeat = ''.repeat || function repeat(count) {
  var str = String(requireObjectCoercible$1(this));
  var result = '';
  var n = toInteger$1(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

// https://github.com/tc39/proposal-string-pad-start-end




var stringPad = function (that, maxLength, fillString, left) {
  var S = String(requireObjectCoercible$1(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength$1(maxLength);
  var fillLen, stringFiller;
  if (intMaxLength <= stringLength || fillStr == '') return S;
  fillLen = intMaxLength - stringLength;
  stringFiller = stringRepeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

// https://github.com/zloirock/core-js/issues/280


// eslint-disable-next-line unicorn/no-unsafe-regex
var webkitStringPadBug = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent$1);

// `String.prototype.padStart` method
// https://tc39.github.io/ecma262/#sec-string.prototype.padstart
_export$1({ target: 'String', proto: true, forced: webkitStringPadBug }, {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return stringPad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

// `SameValue` abstract operation
// https://tc39.github.io/ecma262/#sec-samevalue
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

// @@search logic
fixRegexpWellKnownSymbolLogic$1('search', 1, function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$1(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative(nativeSearch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject$1(regexp);
      var S = String(this);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue$1(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regexpExecAbstract$1(rx, S);
      if (!sameValue$1(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "p,ul{margin:0;padding:0}ul{list-style:none}a{text-decoration:none}";
styleInject(css,{"insertAt":"top"});

var css$1 = ".comment-animate--fade-enter-to,.comment-animate--fade-leave-to{transition:opacity .32s cubic-bezier(.33,0,.33,1)}.comment-animate--fade-enter,.comment-animate--fade-leave-to{opacity:0}.comment-animate--slide-enter-to,.comment-animate--slide-leave-to{transition:-webkit-transform .5s;transition:transform .5s;transition:transform .5s,-webkit-transform .5s}.comment-animate--slide-enter,.comment-animate--slide-leave-to{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}";
styleInject(css$1,{"insertAt":"top"});

var css$2 = ".comment--ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-wrap:normal}.comment--highlight{color:#5193ff}.allComments{overflow:hidden}.none_tips,.report-title{text-align:center}@font-face{font-family:igfont;src:url(//game.gtimg.cn/images/sy/2016/miniweb/ingame/iconfont/v1/iconfont.eot);src:url(//game.gtimg.cn/images/sy/2016/miniweb/ingame/iconfont/v1/iconfont.eot#iefix) format(\"embedded-opentype\"),url(//game.gtimg.cn/images/sy/2016/miniweb/ingame/iconfont/v1/iconfont.svg#iconfont) format(\"svg\"),url(//game.gtimg.cn/images/sy/2016/miniweb/ingame/iconfont/v1/iconfont.woff) format(\"woff\"),url(//game.gtimg.cn/images/sy/2016/miniweb/ingame/iconfont/v1/iconfont.ttf) format(\"truetype\")}.none_tips{font-size:12px;margin-top:20px}.report-title{height:40px;line-height:40px;position:relative;font-size:15px;color:#e0e0e0;background:#213046}.report-title-back{position:absolute;top:0;left:15px;color:#e0e0e0;font-size:18px;line-height:40px}.report-bd h6{background:#273547;height:30px;line-height:30px;text-indent:15px;color:#e0e0e0;margin:0;font-size:11px}.report-bd ul{display:inline-block;width:50%}.np-comment-report-bd{background:#18202f;position:relative;z-index:990;min-height:100%}.report-options li{height:40px;line-height:40px;border-bottom:1px solid #1e2532;font-size:13px;position:relative}.report-options li span{padding-left:15px;color:#e0e0e0}.report-options li .report-options-item{width:20px;height:20px;position:absolute;top:10px;right:10px;background:#2c3548;border-radius:20px;overflow:hidden}.report-options li .report-options-item:after{font-family:igfont!important;font-size:25px;font-style:normal;-webkit-font-smoothing:antialiased;-webkit-text-stroke-width:.2px;-moz-osx-font-smoothing:grayscale;content:\"\\e61c\";position:absolute;top:2px;left:-3px;line-height:20px;color:#fff;opacity:0;text-align:center}.report-sumbit{text-align:center;font-size:13px}.report-options li.selected .report-options-item:after{opacity:1}.report-options li.selected .report-options-item{background:#2c3548}.report-action{padding:10px 15px}.report-sumbit{display:block;width:100%;height:30px;line-height:30px;background:#3c629f;color:#e0e0e0;border-radius:3px}.comment_icon-share_outer{height:12px;width:12px;overflow:hidden;display:inline-block;margin-left:10px}.comment_icon-share{background:url(//ossweb-img.qq.com/images/js/bsCommonFiles/images/comment/comment-sprite.png) -40px -40px no-repeat;background-size:134px 60px}.none{display:none!important}.comment-hidden{height:100%!important;overflow:hidden!important}";
styleInject(css$2,{"insertAt":"top"});

var SPECIES$7 = wellKnownSymbol('species');
var nativeSlice$1 = [].slice;
var max$3 = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('slice') }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES$7];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice$1.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max$3(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING$1 = 'toString';
var nativeDateToString = DatePrototype[TO_STRING$1];
var getTime = DatePrototype.getTime;

// `Date.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-date.prototype.tostring
if (new Date(NaN) + '' != INVALID_DATE) {
  redefine(DatePrototype, TO_STRING$1, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? nativeDateToString.call(this) : INVALID_DATE;
  });
}

var aPossiblePrototype = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf$1 = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    objectSetPrototypeOf$1 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) objectSetPrototypeOf$1($this, NewTargetPrototype);
  return $this;
};

var defineProperty$5 = objectDefineProperty.f;
var getOwnPropertyNames$2 = objectGetOwnPropertyNames.f;







var MATCH$3 = wellKnownSymbol('match');
var NativeRegExp$1 = global_1.RegExp;
var RegExpPrototype$2 = NativeRegExp$1.prototype;
var re1$1 = /a/g;
var re2$1 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW$1 = new NativeRegExp$1(re1$1) !== re1$1;

var FORCED$4 = descriptors && isForced_1('RegExp', (!CORRECT_NEW$1 || fails(function () {
  re2$1[MATCH$3] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return NativeRegExp$1(re1$1) != re1$1 || NativeRegExp$1(re2$1) == re2$1 || NativeRegExp$1(re1$1, 'i') != '/a/i';
})));

// `RegExp` constructor
// https://tc39.github.io/ecma262/#sec-regexp-constructor
if (FORCED$4) {
  var RegExpWrapper$1 = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper$1;
    var patternIsRegExp = isRegexp(pattern);
    var flagsAreUndefined = flags === undefined;
    return !thisIsRegExp && patternIsRegExp && pattern.constructor === RegExpWrapper$1 && flagsAreUndefined ? pattern
      : inheritIfRequired$1(CORRECT_NEW$1
        ? new NativeRegExp$1(patternIsRegExp && !flagsAreUndefined ? pattern.source : pattern, flags)
        : NativeRegExp$1((patternIsRegExp = pattern instanceof RegExpWrapper$1)
          ? pattern.source
          : pattern, patternIsRegExp && flagsAreUndefined ? regexpFlags.call(pattern) : flags)
      , thisIsRegExp ? this : RegExpPrototype$2, RegExpWrapper$1);
  };
  var proxy$1 = function (key) {
    key in RegExpWrapper$1 || defineProperty$5(RegExpWrapper$1, key, {
      configurable: true,
      get: function () { return NativeRegExp$1[key]; },
      set: function (it) { NativeRegExp$1[key] = it; }
    });
  };
  var keys$3 = getOwnPropertyNames$2(NativeRegExp$1);
  var index = 0;
  while (keys$3.length > index) proxy$1(keys$3[index++]);
  RegExpPrototype$2.constructor = RegExpWrapper$1;
  RegExpWrapper$1.prototype = RegExpPrototype$2;
  redefine(global_1, 'RegExp', RegExpWrapper$1);
}

// https://tc39.github.io/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');

var TO_STRING$2 = 'toString';
var RegExpPrototype$3 = RegExp.prototype;
var nativeToString$1 = RegExpPrototype$3[TO_STRING$2];

var NOT_GENERIC$1 = fails(function () { return nativeToString$1.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME$1 = nativeToString$1.name != TO_STRING$2;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC$1 || INCORRECT_NAME$1) {
  redefine(RegExp.prototype, TO_STRING$2, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype$3) ? regexpFlags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

/**
 * @file 工具类函数
 * @author hardylin <hardylin@tencent.com>
 */
// 浏览器判断
var browser = {
  qq: / QQ\//i.test(navigator.userAgent),
  qqBrowser: / MQQBrowser\//i.test(navigator.userAgent) && !/ QQ\/| MicroMessenger\//i.test(navigator.userAgent),
  wechat: / MicroMessenger\//i.test(navigator.userAgent)
  /**
   * 模拟点击事件
   * @param {String | HTMLElement} el - 要模拟点击事件元素的 css 选择器或者 dom 节点
   */

};
function click(el) {
  var event = document.createEvent('MouseEvent') || document.createEvent('MouseEvents');
  event.initMouseEvent('click', true, true, document.defaultView, 0, 0, 0, 0, 0);

  if (typeof el == 'string') {
    el = document.querySelector(el);
  }

  el.dispatchEvent(event);
}
/**
 * 计算字符串的字节长度
 * @param {String} str 要计算的字符串
 * @returns {Number} 字节长度
 */

function computeByteLength(str) {
  var len = 0;

  for (var i = 0, l = str.length; i < l; i++) {
    var c = str.charCodeAt(i);

    if (c >= 0x0001 && c <= 0x007e || 0xff60 <= c && c <= 0xff9f) {
      len++; // 单字节加 1
    } else {
      len += 2;
    }
  }

  return len;
}
/**
 * 格式化时间
 * @param {Number} time - 需要格式化的时间
 * @param {String} str - 时间格式（例如：YYYY-MM-DD hh:mm:ss）
 * @returns {String} - 格式化后的时间字符串
 */

function formatTime(time, str) {
  var date = new Date(time);
  var patterns = {
    'M+': date.getMonth() + 1,
    'D+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };

  if (/Y+/.test(str)) {
    str = str.replace(RegExp.lastMatch, (date.getFullYear() + '').slice(4 - RegExp.lastMatch.length));
  }

  for (var p in patterns) {
    if (new RegExp('(' + p + ')').test(str)) {
      str = str.replace(RegExp.lastMatch, RegExp.lastMatch.length == 1 ? patterns[p] : ('00' + patterns[p]).slice(-2));
    }
  }

  return str;
}
/**
 * 全角转半角
 * @param {String} str - 需要转换的字符串
 * @returns {String} - 转换后的字符串
 */

function fullToHalf(str) {
  var tmp = '';

  for (var i = 0; i < str.length; i++) {
    var charCode = str.charCodeAt(i);
    tmp += charCode > 65248 && charCode < 65375 ? String.fromCharCode(charCode - 65248) : str[i];
  }

  return tmp;
}
/**
 * 获取指定名称的 url 参数
 * @param {String} name - 参数名称
 * @param {String} url - 指定 url，不指定默认为当前页面 url
 * @returns {String} - 参数的值，未找到则返回 null
 */

function getUrlParam(name, url) {
  var reg = new RegExp('(\\?|&)' + name + '=([^&]*)(&|$)');
  var values = reg.exec(url ? url : location.search);
  return values != null ? decodeURIComponent(values[2]) : null;
}
/**
 * 动态加载 script 脚本
 * @param {String} url - 要加载脚本的 url
 * @returns {Object} - Promise 对象
 */

function loadScript(url, charset) {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.onload = resolve;
    script.onerror = reject;
    script.src = url;
    if (charset) script.charset = charset;
    document.body.appendChild(script);
  });
}

/**
 * @file 评论组件依赖
 * @author hardylin <hardylin@tencent.com>
 */

if (browser.qqBrowser) {
  loadScript('//jsapi.qq.com/get?api=login.*');
} // 加载ugc配置


loadScript('//tiem-cdn.qq.com/slugteam/public/config/ugcConfig.js', 'utf-8');

var version = "3.9.7";

/**
 * @file 工具类 - 警告
 * @author hardylin <hardylin@tencent.com>
 */

/**
 * 错误断言
 * @param {Boolean} condition - 条件表达式
 * @param {String} msg - 当 condition 结果为 false 时提示的错误信息
 */
function assert(condition, msg) {
  if (!condition) {
    throw new Error("[Comment] ".concat(msg));
  }
}

/**
 * @file 评论相关接口
 * @author hardylin <hardylin@tencent.com>
 */
var API = {
  USER_INFO: '/user_info.php',
  // 获取用户信息
  COMMENT_LIST: '/comment_list.php',
  // 评论列表
  USER_COMMENT_LIST: '/query_user_comment_list.php',
  // 用户评论列表
  SUBMIT_COMMENT: '/submit_comment.php',
  // 提交评论
  DELETE_COMMENT: '/del_comment.php',
  // 删除评论
  LIKE: '/digg.php',
  // 评论点赞
  REPORT: '/report.php',
  // 举报评论
  REPLY_LIST: '/reply_list.php',
  // 回复列表
  SUBMIT_REPLY: '/submit_reply.php',
  // 提交回复
  DELETE_REPLY: '/del_reply.php' // 删除回复

};

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
var whitespaces$1 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace$1 = '[' + whitespaces$1 + ']';
var ltrim$1 = RegExp('^' + whitespace$1 + whitespace$1 + '*');
var rtrim$1 = RegExp(whitespace$1 + whitespace$1 + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$2 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim$1, '');
    if (TYPE & 2) string = string.replace(rtrim$1, '');
    return string;
  };
};

var stringTrim$1 = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod$2(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod$2(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod$2(3)
};

var getOwnPropertyNames$3 = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;
var defineProperty$6 = objectDefineProperty.f;
var trim = stringTrim$1.trim;

var NUMBER$1 = 'Number';
var NativeNumber$1 = global_1[NUMBER$1];
var NumberPrototype$1 = NativeNumber$1.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF$1 = classofRaw(objectCreate(NumberPrototype$1)) == NUMBER$1;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber$1 = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced_1(NUMBER$1, !NativeNumber$1(' 0o1') || !NativeNumber$1('0b1') || NativeNumber$1('+0x1'))) {
  var NumberWrapper$1 = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper$1
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF$1 ? fails(function () { NumberPrototype$1.valueOf.call(dummy); }) : classofRaw(dummy) != NUMBER$1)
        ? inheritIfRequired$1(new NativeNumber$1(toNumber$1(it)), dummy, NumberWrapper$1) : toNumber$1(it);
  };
  for (var keys$4 = descriptors ? getOwnPropertyNames$3(NativeNumber$1) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j$1 = 0, key$1; keys$4.length > j$1; j$1++) {
    if (has(NativeNumber$1, key$1 = keys$4[j$1]) && !has(NumberWrapper$1, key$1)) {
      defineProperty$6(NumberWrapper$1, key$1, getOwnPropertyDescriptor$4(NativeNumber$1, key$1));
    }
  }
  NumberWrapper$1.prototype = NumberPrototype$1;
  NumberPrototype$1.constructor = NumberWrapper$1;
  redefine(global_1, NUMBER$1, NumberWrapper$1);
}

var nativeGetOwnPropertyNames$2 = objectGetOwnPropertyNames.f;

var toString$2 = {}.toString;

var windowNames$1 = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames$1 = function (it) {
  try {
    return nativeGetOwnPropertyNames$2(it);
  } catch (error) {
    return windowNames$1.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var f$8 = function getOwnPropertyNames(it) {
  return windowNames$1 && toString$2.call(it) == '[object Window]'
    ? getWindowNames$1(it)
    : nativeGetOwnPropertyNames$2(toIndexedObject(it));
};

var objectGetOwnPropertyNamesExternal$1 = {
	f: f$8
};

var f$9 = wellKnownSymbol;

var wrappedWellKnownSymbol$1 = {
	f: f$9
};

var defineProperty$7 = objectDefineProperty.f;

var defineWellKnownSymbol$1 = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty$7(Symbol, NAME, {
    value: wrappedWellKnownSymbol$1.f(NAME)
  });
};

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod$3 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = bindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$3(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod$3(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod$3(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod$3(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod$3(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod$3(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$3(6)
};

var $forEach = arrayIteration.forEach;

var HIDDEN$1 = sharedKey('hidden');
var SYMBOL$1 = 'Symbol';
var PROTOTYPE$2 = 'prototype';
var TO_PRIMITIVE$1 = wellKnownSymbol('toPrimitive');
var setInternalState$4 = internalState.set;
var getInternalState$4 = internalState.getterFor(SYMBOL$1);
var ObjectPrototype$3 = Object[PROTOTYPE$2];
var $Symbol$1 = global_1.Symbol;
var JSON$1 = global_1.JSON;
var nativeJSONStringify$1 = JSON$1 && JSON$1.stringify;
var nativeGetOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var nativeDefineProperty$2 = objectDefineProperty.f;
var nativeGetOwnPropertyNames$3 = objectGetOwnPropertyNamesExternal$1.f;
var nativePropertyIsEnumerable$2 = objectPropertyIsEnumerable.f;
var AllSymbols$1 = shared('symbols');
var ObjectPrototypeSymbols$1 = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore$1 = shared('wks');
var QObject$1 = global_1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER$1 = !QObject$1 || !QObject$1[PROTOTYPE$2] || !QObject$1[PROTOTYPE$2].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor$1 = descriptors && fails(function () {
  return objectCreate(nativeDefineProperty$2({}, 'a', {
    get: function () { return nativeDefineProperty$2(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$2(ObjectPrototype$3, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype$3[P];
  nativeDefineProperty$2(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$3) {
    nativeDefineProperty$2(ObjectPrototype$3, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty$2;

var wrap$1 = function (tag, description) {
  var symbol = AllSymbols$1[tag] = objectCreate($Symbol$1[PROTOTYPE$2]);
  setInternalState$4(symbol, {
    type: SYMBOL$1,
    tag: tag,
    description: description
  });
  if (!descriptors) symbol.description = description;
  return symbol;
};

var isSymbol$1 = nativeSymbol && typeof $Symbol$1.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol$1;
};

var $defineProperty$1 = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype$3) $defineProperty$1(ObjectPrototypeSymbols$1, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols$1, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN$1)) nativeDefineProperty$2(O, HIDDEN$1, createPropertyDescriptor(1, {}));
      O[HIDDEN$1][key] = true;
    } else {
      if (has(O, HIDDEN$1) && O[HIDDEN$1][key]) O[HIDDEN$1][key] = false;
      Attributes = objectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor$1(O, key, Attributes);
  } return nativeDefineProperty$2(O, key, Attributes);
};

var $defineProperties$1 = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols$1(properties));
  $forEach(keys, function (key) {
    if (!descriptors || $propertyIsEnumerable$1.call(properties, key)) $defineProperty$1(O, key, properties[key]);
  });
  return O;
};

var $create$1 = function create(O, Properties) {
  return Properties === undefined ? objectCreate(O) : $defineProperties$1(objectCreate(O), Properties);
};

var $propertyIsEnumerable$1 = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable$2.call(this, P);
  if (this === ObjectPrototype$3 && has(AllSymbols$1, P) && !has(ObjectPrototypeSymbols$1, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols$1, P) || has(this, HIDDEN$1) && this[HIDDEN$1][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor$1 = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype$3 && has(AllSymbols$1, key) && !has(ObjectPrototypeSymbols$1, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor$2(it, key);
  if (descriptor && has(AllSymbols$1, key) && !(has(it, HIDDEN$1) && it[HIDDEN$1][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames$1 = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames$3(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols$1, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols$1 = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$3;
  var names = nativeGetOwnPropertyNames$3(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols$1 : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols$1, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype$3, key))) {
      result.push(AllSymbols$1[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!nativeSymbol) {
  $Symbol$1 = function Symbol() {
    if (this instanceof $Symbol$1) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype$3) setter.call(ObjectPrototypeSymbols$1, value);
      if (has(this, HIDDEN$1) && has(this[HIDDEN$1], tag)) this[HIDDEN$1][tag] = false;
      setSymbolDescriptor$1(this, tag, createPropertyDescriptor(1, value));
    };
    if (descriptors && USE_SETTER$1) setSymbolDescriptor$1(ObjectPrototype$3, tag, { configurable: true, set: setter });
    return wrap$1(tag, description);
  };

  redefine($Symbol$1[PROTOTYPE$2], 'toString', function toString() {
    return getInternalState$4(this).tag;
  });

  objectPropertyIsEnumerable.f = $propertyIsEnumerable$1;
  objectDefineProperty.f = $defineProperty$1;
  objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor$1;
  objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal$1.f = $getOwnPropertyNames$1;
  objectGetOwnPropertySymbols.f = $getOwnPropertySymbols$1;

  if (descriptors) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty$2($Symbol$1[PROTOTYPE$2], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState$4(this).description;
      }
    });
    {
      redefine(ObjectPrototype$3, 'propertyIsEnumerable', $propertyIsEnumerable$1, { unsafe: true });
    }
  }

  wrappedWellKnownSymbol$1.f = function (name) {
    return wrap$1(wellKnownSymbol(name), name);
  };
}

_export({ global: true, wrap: true, forced: !nativeSymbol, sham: !nativeSymbol }, {
  Symbol: $Symbol$1
});

$forEach(objectKeys(WellKnownSymbolsStore$1), function (name) {
  defineWellKnownSymbol$1(name);
});

_export({ target: SYMBOL$1, stat: true, forced: !nativeSymbol }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol$1(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol$1(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER$1 = true; },
  useSimple: function () { USE_SETTER$1 = false; }
});

_export({ target: 'Object', stat: true, forced: !nativeSymbol, sham: !descriptors }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create$1,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty$1,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties$1,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor$1
});

_export({ target: 'Object', stat: true, forced: !nativeSymbol }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames$1,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols$1
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
_export({ target: 'Object', stat: true, forced: fails(function () { objectGetOwnPropertySymbols.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return objectGetOwnPropertySymbols.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
JSON$1 && _export({ target: 'JSON', stat: true, forced: !nativeSymbol || fails(function () {
  var symbol = $Symbol$1();
  // MS Edge converts symbol values to JSON as {}
  return nativeJSONStringify$1([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || nativeJSONStringify$1({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || nativeJSONStringify$1(Object(symbol)) != '{}';
}) }, {
  stringify: function stringify(it) {
    var args = [it];
    var index = 1;
    var replacer, $replacer;
    while (arguments.length > index) args.push(arguments[index++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol$1(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol$1(value)) return value;
    };
    args[1] = replacer;
    return nativeJSONStringify$1.apply(JSON$1, args);
  }
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol$1[PROTOTYPE$2][TO_PRIMITIVE$1]) hide($Symbol$1[PROTOTYPE$2], TO_PRIMITIVE$1, $Symbol$1[PROTOTYPE$2].valueOf);
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol$1, SYMBOL$1);

hiddenKeys[HIDDEN$1] = true;

var defineProperty$8 = objectDefineProperty.f;


var NativeSymbol$1 = global_1.Symbol;

if (descriptors && typeof NativeSymbol$1 == 'function' && (!('description' in NativeSymbol$1.prototype) ||
  // Safari 12 bug
  NativeSymbol$1().description !== undefined
)) {
  var EmptyStringDescriptionStore$1 = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper$1 = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper$1
      ? new NativeSymbol$1(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol$1() : NativeSymbol$1(description);
    if (description === '') EmptyStringDescriptionStore$1[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper$1, NativeSymbol$1);
  var symbolPrototype$1 = SymbolWrapper$1.prototype = NativeSymbol$1.prototype;
  symbolPrototype$1.constructor = SymbolWrapper$1;

  var symbolToString$1 = symbolPrototype$1.toString;
  var native$1 = String(NativeSymbol$1('test')) == 'Symbol(test)';
  var regexp$1 = /^Symbol\((.*)\)[^)]+$/;
  defineProperty$8(symbolPrototype$1, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString$1.call(symbol);
      if (has(EmptyStringDescriptionStore$1, symbol)) return '';
      var desc = native$1 ? string.slice(7, -1) : string.replace(regexp$1, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  _export({ global: true, forced: true }, {
    Symbol: SymbolWrapper$1
  });
}

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol$1('iterator');

var correctPrototypeGetter$1 = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$2 = sharedKey('IE_PROTO');
var ObjectPrototype$4 = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf$1 = correctPrototypeGetter$1 ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype$4 : null;
};

var ITERATOR$6 = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS$2 = false;

var returnThis$3 = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$3, PrototypeOfArrayIteratorPrototype$1, arrayIterator$1;

if ([].keys) {
  arrayIterator$1 = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator$1)) BUGGY_SAFARI_ITERATORS$2 = true;
  else {
    PrototypeOfArrayIteratorPrototype$1 = objectGetPrototypeOf$1(objectGetPrototypeOf$1(arrayIterator$1));
    if (PrototypeOfArrayIteratorPrototype$1 !== Object.prototype) IteratorPrototype$3 = PrototypeOfArrayIteratorPrototype$1;
  }
}

if (IteratorPrototype$3 == undefined) IteratorPrototype$3 = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if ( !has(IteratorPrototype$3, ITERATOR$6)) hide(IteratorPrototype$3, ITERATOR$6, returnThis$3);

var iteratorsCore$1 = {
  IteratorPrototype: IteratorPrototype$3,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$2
};

var IteratorPrototype$4 = iteratorsCore$1.IteratorPrototype;





var returnThis$4 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$4, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  iterators[TO_STRING_TAG] = returnThis$4;
  return IteratorConstructor;
};

var IteratorPrototype$5 = iteratorsCore$1.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$3 = iteratorsCore$1.BUGGY_SAFARI_ITERATORS;
var ITERATOR$7 = wellKnownSymbol('iterator');
var KEYS$1 = 'keys';
var VALUES$1 = 'values';
var ENTRIES$1 = 'entries';

var returnThis$5 = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$3 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS$1: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES$1: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES$1: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$7]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$3 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf$1(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype$5 !== Object.prototype && CurrentIteratorPrototype.next) {
      if ( objectGetPrototypeOf$1(CurrentIteratorPrototype) !== IteratorPrototype$5) {
        if (objectSetPrototypeOf$1) {
          objectSetPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype$5);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$7] != 'function') {
          hide(CurrentIteratorPrototype, ITERATOR$7, returnThis$5);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES$1 && nativeIterator && nativeIterator.name !== VALUES$1) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ( IterablePrototype[ITERATOR$7] !== defaultIterator) {
    hide(IterablePrototype, ITERATOR$7, defaultIterator);
  }
  iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES$1),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS$1),
      entries: getIterationMethod(ENTRIES$1)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$3 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$3 || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var ARRAY_ITERATOR$1 = 'Array Iterator';
var setInternalState$5 = internalState.set;
var getInternalState$5 = internalState.getterFor(ARRAY_ITERATOR$1);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
var es_array_iterator$1 = defineIterator$1(Array, 'Array', function (iterated, kind) {
  setInternalState$5(this, {
    type: ARRAY_ITERATOR$1,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$5(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
iterators.Arguments = iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

var codeAt = stringMultibyte.codeAt;

// `String.prototype.codePointAt` method
// https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
_export({ target: 'String', proto: true }, {
  codePointAt: function codePointAt(pos) {
    return codeAt(this, pos);
  }
});

var fromCharCode$1 = String.fromCharCode;
var nativeFromCodePoint$1 = String.fromCodePoint;

// length should be 1, old FF problem
var INCORRECT_LENGTH$1 = !!nativeFromCodePoint$1 && nativeFromCodePoint$1.length != 1;

// `String.fromCodePoint` method
// https://tc39.github.io/ecma262/#sec-string.fromcodepoint
_export({ target: 'String', stat: true, forced: INCORRECT_LENGTH$1 }, {
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw RangeError(code + ' is not a valid code point');
      elements.push(code < 0x10000
        ? fromCharCode$1(code)
        : fromCharCode$1(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00)
      );
    } return elements.join('');
  }
});

var charAt$1 = stringMultibyte.charAt;



var STRING_ITERATOR$1 = 'String Iterator';
var setInternalState$6 = internalState.set;
var getInternalState$6 = internalState.getterFor(STRING_ITERATOR$1);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator$1(String, 'String', function (iterated) {
  setInternalState$6(this, {
    type: STRING_ITERATOR$1,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$6(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt$1(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables$1 = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var ITERATOR$8 = wellKnownSymbol('iterator');
var TO_STRING_TAG$4 = wellKnownSymbol('toStringTag');
var ArrayValues$1 = es_array_iterator$1.values;

for (var COLLECTION_NAME$2 in domIterables$1) {
  var Collection$2 = global_1[COLLECTION_NAME$2];
  var CollectionPrototype$2 = Collection$2 && Collection$2.prototype;
  if (CollectionPrototype$2) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype$2[ITERATOR$8] !== ArrayValues$1) try {
      hide(CollectionPrototype$2, ITERATOR$8, ArrayValues$1);
    } catch (error) {
      CollectionPrototype$2[ITERATOR$8] = ArrayValues$1;
    }
    if (!CollectionPrototype$2[TO_STRING_TAG$4]) hide(CollectionPrototype$2, TO_STRING_TAG$4, COLLECTION_NAME$2);
    if (domIterables$1[COLLECTION_NAME$2]) for (var METHOD_NAME$1 in es_array_iterator$1) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype$2[METHOD_NAME$1] !== es_array_iterator$1[METHOD_NAME$1]) try {
        hide(CollectionPrototype$2, METHOD_NAME$1, es_array_iterator$1[METHOD_NAME$1]);
      } catch (error) {
        CollectionPrototype$2[METHOD_NAME$1] = es_array_iterator$1[METHOD_NAME$1];
      }
    }
  }
}

/**
 * @file 工具类 - 字符串
 * @author hardylin <hardylin@tencent.com>
 */

/**
 * 对 4 个字节字符进行编码（emoji 表情）
 * @param {String} str - 需要处理的字符串
 * @returns {String} 处理后的字符串
 */
function encodeUnicode(str) {
  var temp = '';
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = str[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var char = _step.value;

      if (char.codePointAt(0) > 0xffff) {
        temp += "[u:".concat(char.codePointAt(0), "]");
      } else {
        temp += char;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return temp;
}
/**
 * 对 4 个字节字符进行解码（emoji 表情）
 * @param {String} str - 需要处理的字符串
 * @returns {String} 处理后的字符串，4 个字节字符将被换成
 */

function decodeUnicode(str) {
  return str.replace(/\[u:(\d+)\]/g, function ($1, $2) {
    return String.fromCodePoint($2);
  });
}
/**
 * 全角转半角（只转换部分字符）
 * @param {String} str - 需要处理的字符串
 * @returns {String} 处理后的字符串
 */

function fullToHalf$1(str) {
  return str.replace(/／/g, '/').replace(/＆/g, '&').replace(/；/g, ';').replace(/＝/g, '=').replace(/＜br＞/g, '<br>').replace(/＜\/?div＞/g, '');
}

var script = {
  name: 'comment-barrage',
  props: {
    barrages: {
      // 全部弹幕数据
      type: Array,
      required: true
    },
    avatar: {
      // 弹幕头像字段
      type: String,
      required: true
    },
    content: {
      // 弹幕内容字段
      type: String,
      required: true
    },
    line: {
      // 同时展示条数
      type: Number,
      default: 5
    },
    rate: {
      // 滚动速率
      type: Number,
      default: 2000
    },
    background: {
      // 弹幕背景颜色
      type: String,
      default: '#235a90'
    }
  },
  data: function data() {
    var height = 20; // 每条弹幕高度

    var margin = 4; // 每条弹幕垂直外边距

    return {
      part1: {
        barrages: [],
        // 活跃弹幕数据
        y: 0,
        // translate 的 y 坐标
        hide: false // 是否隐藏元素

      },
      part2: {
        barrages: [],
        y: 0,
        hide: false
      },
      index: 0,
      // 弹幕索引
      offset: height + margin,
      // 一条弹幕的偏移量
      height: height,
      margin: margin
    };
  },
  computed: {
    partHeight: function partHeight() {
      // 可视部分高度
      return this.line * this.offset;
    },
    rootStyle: function rootStyle() {
      return {
        height: "".concat(this.partHeight, "px"),
        paddingTop: "".concat(this.partHeight - this.margin / 2, "px") // 减去一半外边距

      };
    },
    part1Style: function part1Style() {
      return {
        transform: "translate3d(0, ".concat(this.part1.y, "px, 0)")
      };
    },
    part2Style: function part2Style() {
      return {
        transform: "translate3d(0, ".concat(this.part2.y, "px, 0)")
      };
    },
    barrageStyle: function barrageStyle() {
      // 每条弹幕样式
      return {
        background: this.background
      };
    }
  },
  watch: {
    'barrages': function barrages(newVal, oldVal) {
      if (oldVal.length === 0 && newVal.length > 0) {
        this.part1.barrages = this.nextBarrages();
        this.part2.barrages = this.nextBarrages();
      } // 弹幕变少之后索引重置


      if (this.index >= newVal.length) {
        this.index = 0;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.barrages.length > 0) {
      this.part1.barrages = this.nextBarrages();
      this.part2.barrages = this.nextBarrages();
    }

    this.timer = setInterval(function () {
      _this.part1.hide = false;
      _this.part2.hide = false;
      _this.part1.y -= _this.offset;
      _this.part2.y -= _this.offset; // 超出显示区域时，在动画执行完成后复位并更新弹幕数据，复位时隐藏动画

      if (_this.part1.y <= -2 * _this.partHeight) {
        setTimeout(function () {
          _this.part1.hide = true;
          _this.part1.y = 0;
          _this.part1.barrages = _this.nextBarrages();
        }, 500);
      }

      if (_this.part2.y <= -3 * _this.partHeight) {
        setTimeout(function () {
          _this.part2.hide = true;
          _this.part2.y = -_this.partHeight;
          _this.part2.barrages = _this.nextBarrages();
        }, 500);
      }
    }, this.rate);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    /**
     * 获取下一组弹幕
     * @returns {Array} - 最新弹幕数据数组
     */
    nextBarrages: function nextBarrages() {
      if (this.barrages.length == 0) {
        return [];
      }

      var index = this.index + this.line;
      var arr = this.barrages.slice(this.index, index); // 末尾弹幕条数不足则从头取

      while (arr.length < this.line) {
        index = this.line - arr.length;
        arr = arr.concat(this.barrages.slice(0, index));
      }

      this.index = index;
      return arr;
    },

    /**
     * 格式化弹幕内容
     * @param {String} content - 弹幕内容
     * @returns {String} - 格式化后的弹幕内容
     */
    formatContent: function formatContent(content) {
      content = decodeUnicode(content);
      return content.replace(/\[e:(\d+)\]/g, function ($1, $2) {
        return '<img src="//ossweb-img.qq.com/images/js/bsCommonFiles/images/qqemotion/' + $2 + '.png" style="display:inline-block;width:16px;margin-top:2px">';
      });
    },

    /**
     * 格式化头像
     * @param {String} str - 需要格式化的头像 URL
     * @returns {String} - 格式化后的头像 URL
     */
    formatAvatar: function formatAvatar(str) {
      return fullToHalf(str.replace(/^https?:/, ''));
    }
  }
};

var css$3 = ".comment-barrage{z-index:970;position:fixed;bottom:50px;left:10px;box-sizing:border-box;max-width:60vw;overflow:hidden;font-size:12px;color:#fff}.comment-barrage--hidden{visibility:hidden}.comment-barrage ul{transition:-webkit-transform .5s;transition:transform .5s;transition:transform .5s,-webkit-transform .5s}.comment-barrage li{display:-webkit-flex;display:flex;height:20px;margin:4px 0}.comment-barrage--item{display:-webkit-flex;display:flex;-webkit-align-items:center;align-items:center;overflow:hidden;border-radius:10px;padding-right:12px}.comment-barrage--avatar{-webkit-flex:none;flex:none;width:20px;height:20px;border-radius:50%;margin-right:6px;background:rgba(0,0,0,.1) no-repeat 50%/cover}";
styleInject(css$3,{"insertAt":"top"});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "comment-barrage",
    style: _vm.rootStyle
  }, [_c("ul", {
    class: {
      "comment-barrage--hidden": _vm.part1.hide
    },
    style: _vm.part1Style
  }, _vm._l(_vm.part1.barrages, function (barrage, index) {
    return _c("li", {
      key: index
    }, [_c("div", {
      staticClass: "comment-barrage--item",
      style: _vm.barrageStyle
    }, [_c("div", {
      staticClass: "comment-barrage--avatar",
      style: {
        "background-image": "url(" + _vm.formatAvatar(barrage[_vm.avatar]) + ")"
      }
    }), _vm._v(" "), _c("div", {
      staticClass: "comment--ellipsis",
      domProps: {
        innerHTML: _vm._s(_vm.formatContent(barrage[_vm.content]))
      }
    })])]);
  }), 0), _vm._v(" "), _c("ul", {
    class: {
      "comment-barrage--hidden": _vm.part2.hide
    },
    style: _vm.part2Style
  }, _vm._l(_vm.part2.barrages, function (barrage, index) {
    return _c("li", {
      key: index
    }, [_c("div", {
      staticClass: "comment-barrage--item",
      style: _vm.barrageStyle
    }, [_c("div", {
      staticClass: "comment-barrage--avatar",
      style: {
        "background-image": "url(" + _vm.formatAvatar(barrage[_vm.avatar]) + ")"
      }
    }), _vm._v(" "), _c("div", {
      staticClass: "comment--ellipsis",
      domProps: {
        innerHTML: _vm._s(_vm.formatContent(barrage[_vm.content]))
      }
    })])]);
  }), 0)]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

var Barrage = normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
var script$1 = {
  name: 'comment-add-bar',
  data: function data() {
    return {
      visible: true,
      timer: 0,
      // 定时器
      clientY: 0 // touch 事件 y 坐标

    };
  },
  computed: {
    total: function total() {
      return this.$comment.comments.total;
    }
  },
  mounted: function mounted() {
    document.addEventListener('touchstart', this.handleTouchStart.bind(this));
    document.addEventListener('touchmove', this.handleTouchMove.bind(this));
    document.addEventListener('touchend', this.handleTouchEnd.bind(this));
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('touchstart', this.handleTouchStart);
    document.removeEventListener('touchstart', this.handleTouchMove);
    document.addEventListener('touchend', this.handleTouchEnd);
  },
  methods: {
    addComment: function addComment() {
      if (window.__UgcConfig && window.__UgcConfig.comment === false) {
        this.$comment._vm.$toast(window.__UgcConfig.tips);

        return;
      }

      this.$comment._vm.$emit('input');
    },
    handleTouchStart: function handleTouchStart(event) {
      this.clientY = event.touches[0].clientY;
    },
    handleTouchMove: function handleTouchMove(event) {
      if (Math.abs(event.touches[0].clientY - this.clientY) > 10) {
        clearTimeout(this.timer);
        this.visible = false;
      }
    },
    handleTouchEnd: function handleTouchEnd() {
      var _this = this;

      this.timer = setTimeout(function () {
        _this.visible = true;
      }, 1000);
    }
  }
};

var css$4 = ".comment-add-bar{display:-webkit-flex;display:flex;z-index:980;position:fixed;right:0;bottom:0;left:0;padding:5px 10px;padding-right:max(10px,env(safe-area-inset-right));padding-bottom:max(5x,env(safe-area-inset-bottom));padding-left:max(10px,env(safe-area-inset-left));background:#fff linear-gradient(180deg,#e4e4e4,#e4e4e4 66.6%,transparent 0) no-repeat top/100% 1px}.comment-add-bar--input{-webkit-flex:auto;display:-webkit-flex;flex:auto;display:flex;-webkit-align-items:center;align-items:center;height:28px;border:1px solid rgba(0,0,0,.1);border-radius:4px;color:grey}.comment-add-bar--input:before{content:\"\";height:12px;width:12px;margin:0 6px;background:url(//ossweb-img.qq.com/images/js/bsCommonFiles/images/comment/comment-sprite.png) -52px -40px no-repeat/134px 60px}.comment-add-bar--all{-webkit-flex:none;display:-webkit-flex;-webkit-justify-content:center;-webkit-align-items:center;flex:none;display:flex;justify-content:center;align-items:center;height:30px;margin-left:10px;border-radius:4px;padding:0 12px;font-size:12px;color:#fff;background:#5193ff}";
styleInject(css$4,{"insertAt":"top"});

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("transition", {
    attrs: {
      name: "comment-animate--slide"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "comment-add-bar",
    class: ["comment--theme-" + _vm.$comment._config.theme]
  }, [_c("div", {
    staticClass: "comment-add-bar--input",
    on: {
      click: _vm.addComment
    }
  }, [_vm._v("发表评论")]), _vm._v(" "), _vm.$comment._config.allCommentUrl ? _c("a", {
    staticClass: "comment-add-bar--all",
    attrs: {
      href: _vm.$comment._config.allCommentUrl
    }
  }, [_vm._v("所有评论（" + _vm._s(_vm.total) + "条）")]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)]);
};

var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

var AddBar = normalizeComponent_1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$2 = {
  name: 'comment-add-button',
  methods: {
    addComment: function addComment() {
      this.$comment._vm.$emit('input');
    }
  }
};

var css$5 = ".comment-add-button{-webkit-flex:none;display:-webkit-flex;-webkit-justify-content:center;-webkit-align-items:center;flex:none;display:flex;justify-content:center;align-items:center;width:102px;height:30px;font-size:14px;color:#fff;background:#5193ff}";
styleInject(css$5,{"insertAt":"top"});

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "comment-add-button",
    on: {
      click: _vm.addComment
    }
  }, [_vm._t("default", [_vm._v("发表评论")])], 2);
};

var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

var AddButton = normalizeComponent_1({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, undefined, undefined);

var max$4 = Math.max;
var min$4 = Math.min;
var MAX_SAFE_INTEGER$2 = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.splice
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !arrayMethodHasSpeciesSupport('splice') }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$4(max$4(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER$2) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});

var sloppyArrayMethod$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !method || !fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $indexOf = arrayIncludes.indexOf;


var nativeIndexOf$1 = [].indexOf;

var NEGATIVE_ZERO$1 = !!nativeIndexOf$1 && 1 / [1].indexOf(1, -0) < 0;
var SLOPPY_METHOD$2 = sloppyArrayMethod$1('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
_export({ target: 'Array', proto: true, forced: NEGATIVE_ZERO$1 || SLOPPY_METHOD$2 }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO$1
      // convert -0 to +0
      ? nativeIndexOf$1.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var defineProperty$9 = objectDefineProperty.f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (descriptors && !(NAME in FunctionPrototype)) {
  defineProperty$9(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}

var trim$1 = stringTrim$1.trim;


var nativeParseInt$1 = global_1.parseInt;
var hex$1 = /^[+-]?0[Xx]/;
var FORCED$5 = nativeParseInt$1(whitespaces$1 + '08') !== 8 || nativeParseInt$1(whitespaces$1 + '0x16') !== 22;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
var _parseInt$1 = FORCED$5 ? function parseInt(string, radix) {
  var S = trim$1(String(string));
  return nativeParseInt$1(S, (radix >>> 0) || (hex$1.test(S) ? 16 : 10));
} : nativeParseInt$1;

// `parseInt` method
// https://tc39.github.io/ecma262/#sec-parseint-string-radix
_export({ global: true, forced: parseInt != _parseInt$1 }, {
  parseInt: _parseInt$1
});

var script$3 = {
  name: 'comment-item',
  props: {
    comment: {
      type: Object,
      required: true
    },
    from: {
      // 显示文章来源
      type: Boolean,
      default: false
    },
    mini: {
      // 简化回复信息
      type: Boolean,
      default: false
    },
    actionBtn: {
      // 显示操作按钮
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      showOperatePop: false,
      busy: false,
      more: true
    };
  },
  computed: {
    openid: function openid() {
      return this.$comment.userInfo.openid;
    },
    officialAccount: function officialAccount() {
      return this.$comment._vm.officialAccount;
    },
    avatar: function avatar() {
      var avatar = this.comment.imgurl || this.comment.repimgurl || '';
      return fullToHalf$1(avatar).replace(/^https?:/, '');
    },
    content: function content() {
      var str = decodeUnicode(this.comment.content);
      str = str.replace(/\[e:(\d+)\]/g, function ($1, $2) {
        return '<img src="//ossweb-img.qq.com/images/js/bsCommonFiles/images/qqemotion/' + $2 + '.png" style="display: inline; width: 20px;">';
      });
      return fullToHalf$1(str);
      return str;
    }
  },
  filters: {
    formatTime: function formatTime$1(str) {
      str = parseInt(str);
      var today = new Date();
      var length = parseInt(today.getTime() / 1000) - str,
          result;

      if (length < 60) {
        result = '刚刚';
      } else if (length < 3600) {
        result = parseInt(length / 60) + '分钟前';
      } else if (length < 18000) {
        result = parseInt(length / 3600) + '小时前';
      } else if (length < 86400) {
        result = today.getDate() === new Date(str * 1000).getDate() ? '今天' : '昨天';
      } else if (length < 172800) {
        result = '昨天';
      } else {
        result = formatTime(str * 1000, 'YYYY-M-D h:mm');
      }

      return result;
    }
  },
  methods: {
    loadRelays: function loadRelays() {
      var _this = this;

      if (this.more) {
        var _this$$comment$_confi = this.$comment._config.options.num,
            num = _this$$comment$_confi === void 0 ? 8 : _this$$comment$_confi;
        this.busy = true;
        this.$comment.ajax({
          url: 'REPLY_LIST',
          data: {
            stime: this.comment.stime,
            objid: this.comment.objid,
            commid: this.comment.commid,
            ctime: this.comment.ctime,
            ltime: this.comment.replys[this.comment.replys.length - 1].rtime,
            num: num
          },
          success: function success(data) {
            var replys = data && data.replys ? data.replys : [];
            _this.comment.replys = _this.comment.replys.concat(replys);

            if (replys.length < num) {
              _this.more = false;
            }

            _this.$nextTick(function () {
              _this.busy = false;
            });
          }
        });
      }
    },

    /**
     * 删除回复
     * @param {Object} reply - 回复对象
     * @param {Number} index - 回复索引
     */
    deleteReply: function deleteReply(reply, index) {
      var _this2 = this;

      this.$comment.ajax({
        url: 'DELETE_REPLY',
        data: {
          stime: this.comment.stime,
          objid: this.comment.objid,
          commid: this.comment.commid,
          ctime: this.comment.ctime,
          repid: reply.repid,
          rtime: reply.rtime
        },
        success: function success() {
          _this2.comment.replys.splice(index, 1);

          _this2.$toast('删除成功');
        }
      });
    },
    likeComment: function likeComment() {
      var _this3 = this;

      if (this.$comment._login.login_type) {
        this.$comment.ajax({
          url: 'LIKE',
          data: {
            stime: this.comment.stime,
            objid: this.comment.objid,
            ctime: this.comment.ctime,
            commid: this.comment.commid,
            action: this.comment.oper_status ? 'cancel' : 'digg'
          },
          success: function success() {
            _this3.$toast(_this3.comment.oper_status ? '取消点赞成功' : '点赞成功');

            _this3.comment.likenum += _this3.comment.oper_status ? -1 : 1;
            _this3.comment.oper_status = _this3.comment.oper_status ? 0 : 1;
          }
        });
      } else {
        this.$emit('login');
      }
    },
    reportComment: function reportComment() {
      if (this.$comment._login.login_type) {
        if (this.comment.report_status == 1) {
          this.$toast('您的举报已收到');
          return;
        }

        this.$emit('report');
      } else {
        this.$emit('login');
      }
    },

    /**
     * 格式化评论内容
     * @param {String} str - 需要格式化的评论内容
     * @returns {String} - 格式化后的评论内容
     */
    formatComment: function formatComment(str) {
      str = decodeUnicode(str);
      str = str.replace(/\[e:(\d+)\]/g, function ($1, $2) {
        return '<img src="//ossweb-img.qq.com/images/js/bsCommonFiles/images/qqemotion/' + $2 + '.png" style="width:20px;display:inline;">';
      });
      return fullToHalf$1(str);
      return str;
    },

    /**
     * 点击头像
     */
    clickAvatar: function clickAvatar() {
      this.$comment._vm.$emit('avatarClick', this.comment); //this.$comment._vm.$emit('clickava')

    }
  }
};

var css$6 = ".comment-item{padding:12px;font-size:14px;color:#333;background:linear-gradient(180deg,rgba(0,0,0,.1),rgba(0,0,0,.1) 66.6%,transparent 0) no-repeat top/100% 1px}.comment-item--header{display:-webkit-flex;-webkit-align-items:center;display:flex;align-items:center}.comment-item--avatar{-webkit-flex:none;flex:none;width:32px;height:32px;margin-right:12px;border-radius:50%;background:no-repeat 50%/contain}.comment-item--user{-webkit-flex:auto;flex:auto;overflow:hidden}.comment-item--name{display:-webkit-flex;-webkit-align-items:center;display:flex;align-items:center}.comment-item--office{-webkit-flex:none;flex:none;width:20px;height:20px;background:url(//ossweb-img.qq.com/images/js/bsCommonFiles/images/official.png) no-repeat 50%/120% 120%}.comment-item--reply-text{-webkit-flex:none;flex:none;color:#999}.comment-item--time{font-size:12px;color:grey}.comment-item--like,.comment-item--operate{-webkit-flex:-webkit-none;flex:-webkit-none;-webkit-align-self:stretch;-webkit-display:flex;-webkit-align-items:center;-webkit-flex:none;flex:none;align-self:stretch;display:flex;align-items:center;padding:0 6px}[class|=comment-item--like-heart]{width:12px;height:11px;margin-left:4px;background:url(//ossweb-img.qq.com/images/yxzj/ingame/res/icon_xin_Kong.png) no-repeat 50%/100% 100%}.comment-item--like-heart-full{background-image:url(//ossweb-img.qq.com/images/yxzj/ingame/res/icon_xin.png)}.comment-item--operate{position:relative}.comment-item--operate-icon{width:15px;height:9px;background:url(//ossweb-img.qq.com/images/js/bsCommonFiles/images/comment/comment-sprite.png) no-repeat -64px -40px/134px 60px}.comment-item--operate-pop{position:absolute;top:-2px;right:24px;width:134px;height:40px;font-size:0;background:url(//ossweb-img.qq.com/images/js/bsCommonFiles/images/comment/comment-sprite.png) no-repeat 0 0/134px 60px}.comment-item--operate-pop-btn{display:inline-block;width:42px;height:100%}.comment-item--body{margin:6px 0 0 42px}.comment-item--content{word-break:break-all}.comment-item--reply-mini{margin-top:12px;padding:4px 12px;background:rgba(0,0,0,.03)}.comment-item--reply-mini-item{margin:6px 0}.comment-item .comment-item{margin-bottom:1px;background:rgba(0,0,0,.03)}.comment-item--reply{margin-top:12px}.comment-item--reply-item{padding:6px 6px 0;text-align:right}.comment-item--footer{display:-webkit-flex;-webkit-align-items:center;display:flex;align-items:center;height:30px;overflow:hidden;margin:12px 0 0 42px;border:1px solid rgba(0,0,0,.03);background:rgba(0,0,0,.03);padding:0 12px}.comment-item--from{-webkit-flex:none;flex:none}.comment--theme-dark.comment-item{color:#999}.comment--theme-dark .comment-item--reply-mini,.comment--theme-dark.comment-item .comment-item{background:rgba(0,0,0,.06)}.comment--theme-dark .comment-item--reply-text{color:#666}.comment--theme-dark .comment-item--footer{border:1px solid rgba(0,0,0,.04);background:rgba(0,0,0,.06)}";
styleInject(css$6,{"insertAt":"top"});

var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "comment-item",
    class: ["comment--theme-" + _vm.$comment._config.theme]
  }, [_c("div", {
    staticClass: "comment-item--header"
  }, [_c("div", {
    staticClass: "comment-item--avatar",
    style: {
      "background-image": "url(" + (_vm.avatar ? _vm.avatar : "//game.gtimg.cn/images/hlddz/ingame2015/v4/default-avater.png") + ")"
    },
    on: {
      click: _vm.clickAvatar
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "comment-item--user"
  }, [_c("div", {
    staticClass: "comment-item--name"
  }, [_c("div", {
    staticClass: "comment--ellipsis"
  }, [_vm._v(_vm._s(_vm.comment.name || _vm.comment.repname))]), _vm._v(" "), _vm.officialAccount[_vm.$comment._config.options.gameid] && (_vm.officialAccount[_vm.$comment._config.options.gameid].includes(_vm.comment.commid) || _vm.officialAccount[_vm.$comment._config.options.gameid].includes(_vm.comment.repid)) ? _c("div", {
    staticClass: "comment-item--office"
  }) : _vm._e(), _vm._v(" "), _vm.comment.passrepname ? [_c("div", {
    staticClass: "comment-item--reply-text"
  }, [_vm._v(" 回复 ")]), _vm._v(" "), _c("div", {
    staticClass: "comment--ellipsis"
  }, [_vm._v(_vm._s(_vm.comment.passrepname))])] : _vm._e()], 2), _vm._v(" "), _c("div", {
    staticClass: "comment-item--time comment--ellipsis"
  }, [_vm._v(_vm._s(_vm._f("formatTime")(_vm.comment.ctime || _vm.comment.rtime)))])]), _vm._v(" "), _vm.actionBtn ? [_c("div", {
    staticClass: "comment-item--like",
    on: {
      click: _vm.likeComment
    }
  }, [_c("div", [_vm._v(_vm._s(_vm.comment.likenum))]), _vm._v(" "), _c("div", {
    class: {
      "comment-item--like-heart": !_vm.comment.oper_status,
      "comment-item--like-heart-full": _vm.comment.oper_status
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "comment-item--operate",
    on: {
      click: function click($event) {
        _vm.showOperatePop = !_vm.showOperatePop;
      }
    }
  }, [_c("div", {
    staticClass: "comment-item--operate-icon"
  }), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showOperatePop,
      expression: "showOperatePop"
    }],
    staticClass: "comment-item--operate-pop"
  }, [_c("div", {
    staticClass: "comment-item--operate-pop-btn",
    on: {
      click: _vm.reportComment
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "comment-item--operate-pop-btn",
    on: {
      click: _vm.likeComment
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "comment-item--operate-pop-btn",
    on: {
      click: function click($event) {
        return _vm.$emit("reply", _vm.comment);
      }
    }
  })])])] : _vm._e()], 2), _vm._v(" "), _c("div", {
    staticClass: "comment-item--body"
  }, [_c("div", {
    staticClass: "comment-item--content",
    domProps: {
      innerHTML: _vm._s(_vm.content)
    },
    on: {
      click: function click($event) {
        return _vm.$emit("reply", _vm.comment);
      }
    }
  }), _vm._v(" "), _vm.comment.commid == _vm.openid || _vm.comment.repid == _vm.openid ? _c("div", {
    staticClass: "comment-item--reply-item comment--highlight"
  }, [_c("span", {
    on: {
      click: function click($event) {
        return _vm.$emit("delete");
      }
    }
  }, [_vm._v("删除")])]) : _vm._e(), _vm._v(" "), _vm.mini && _vm.comment.replys && _vm.comment.replys.length > 0 ? _c("ul", {
    staticClass: "comment-item--reply-mini"
  }, [_vm._l(_vm.comment.replys, function (reply) {
    return _c("li", {
      staticClass: "comment-item--reply-mini-item",
      on: {
        click: function click($event) {
          return _vm.$emit("reply", _vm.comment, reply);
        }
      }
    }, [_c("span", [_vm._v(_vm._s(reply.repname))]), _vm._v(" "), reply.passrepname ? [_c("span", {
      staticClass: "comment-item--reply-text"
    }, [_vm._v(" 回复 ")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(reply.passrepname))])] : _vm._e(), _vm._v(" "), _c("span", [_vm._v("：")]), _vm._v(" "), _c("span", {
      domProps: {
        innerHTML: _vm._s(_vm.formatComment(reply.content))
      }
    })], 2);
  }), _vm._v(" "), _vm.comment.rnum > 2 && _vm.more ? _c("li", {
    staticClass: "comment-item--reply-mini-item comment--highlight",
    on: {
      click: _vm.loadRelays
    }
  }, [_vm._v("查看更多回复")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), !_vm.mini && _vm.comment.replys && _vm.comment.replys.length > 0 ? _c("div", {
    staticClass: "comment-item--reply"
  }, [_vm._l(_vm.comment.replys, function (_reply, index) {
    return _c("comment-item", {
      attrs: {
        comment: _reply,
        "action-btn": false
      },
      on: {
        delete: function _delete($event) {
          return _vm.deleteReply(_reply, index);
        },
        reply: function reply($event) {
          return _vm.$emit("reply", _vm.comment, _reply);
        }
      }
    });
  }), _vm._v(" "), _vm.comment.rnum > 2 && _vm.more ? _c("div", {
    staticClass: "comment-item--reply-item comment--highlight",
    on: {
      click: _vm.loadRelays
    }
  }, [_vm._v("查看更多回复")]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _vm.from ? _c("a", {
    staticClass: "comment-item--footer",
    attrs: {
      href: decodeURIComponent(_vm.comment.obj_url_mobile)
    }
  }, [_c("span", {
    staticClass: "comment-item--from"
  }, [_vm._v("来自" + _vm._s(_vm.comment.objid.indexOf("topics_mobile") >= 0 ? "话题" : "文章") + "：")]), _vm._v(" "), _c("span", {
    staticClass: "comment--highlight comment--ellipsis"
  }, [_vm._v(_vm._s(_vm.comment.title))])]) : _vm._e()]);
};

var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

var CommentItem = normalizeComponent_1({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, undefined, undefined);

//
//
//
//
//
var script$4 = {
  name: 'comment-textarea',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      html: '',
      lock: false
    };
  },
  watch: {
    'value': function value(nv) {
      if (!this.lock) {
        this.$el.innerHTML = nv; // v-html bug: 若本次赋值与上次赋值一致，innerHTML 不会被更新
      }
    }
  },
  methods: {
    inputEvent: function inputEvent(event) {
      this.$emit('input', event.target.innerHTML);
      this.$emit('range', window.getSelection().getRangeAt(0));
    },
    getSelection: function getSelection() {
      this.$emit('range', window.getSelection().getRangeAt(0));
    }
  }
};

var css$7 = ".comment-textarea{overflow:auto;border:1px solid rgba(0,0,0,.1);outline:none;-webkit-user-select:auto;user-select:auto}";
styleInject(css$7,{"insertAt":"top"});

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "comment-textarea",
    attrs: {
      contenteditable: "true"
    },
    on: {
      click: _vm.getSelection,
      input: _vm.inputEvent,
      focus: function focus($event) {
        _vm.lock = true;
      },
      blur: function blur($event) {
        _vm.lock = false;
      },
      touchmove: function touchmove($event) {
        $event.stopPropagation();
      }
    }
  });
};

var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

var slTextarea = normalizeComponent_1({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$5 = {
  data: function data() {
    return {
      page: 0,
      childElementCount: 0,
      d_list: null,
      transform: '',
      originX: 0,
      // touch 事件初始 x 坐标
      minX: 0,
      // touch 事件最小可偏移 x 坐标
      childWidth: 0 // 每页宽度

    };
  },
  mounted: function mounted() {
    this.d_list = this.$el.querySelector('.sl-slide-list');
    this.d_list.style.width = "".concat(this.d_list.childElementCount * 100, "%");
    this.childElementCount = this.d_list.childElementCount;
  },
  methods: {
    touchStart: function touchStart(event) {
      this.childWidth = this.d_list.offsetWidth / this.d_list.childElementCount;
      this.minX = this.childWidth - this.d_list.offsetWidth;
      this.d_list.style.transition = '';
      this.originX = event.targetTouches[0].clientX;
      this.transform = this.d_list.style.transform ? this.d_list.style.transform : 'translate3d(0px, 0px, 0px)';
    },
    touchMove: function touchMove(event) {
      var _this = this;

      this.d_list.style.transform = this.transform.replace(/(.+\()(-?\d+\.?\d*)(.+)/, function (str, s1, s2, s3) {
        s2 = parseInt(s2) + event.targetTouches[0].clientX - _this.originX;
        s2 = s2 > _this.minX ? s2 : _this.minX;
        return "".concat(s1).concat(s2 < 0 ? s2 : 0).concat(s3);
      });
    },
    touchEnd: function touchEnd(event) {
      var _this2 = this;

      this.d_list.style.transition = 'transform 0.3s';
      this.d_list.style.transform = this.d_list.style.transform.replace(/(.+\()(-?\d+\.?\d*)(.+)/, function (str, s1, s2, s3) {
        var remainder = parseInt(s2) % _this2.childWidth;

        s2 = event.changedTouches[0].clientX < _this2.originX ? parseInt(s2) - remainder - _this2.childWidth : parseInt(s2) - remainder;
        s2 = s2 > _this2.minX ? s2 : _this2.minX;
        _this2.page = Math.abs(parseInt(s2 / _this2.childWidth));
        return "".concat(s1).concat(s2).concat(s3);
      });
    }
  }
};

var css$8 = ".sl-slide{overflow:hidden}.sl-slide-list{display:-webkit-flex;display:flex}.sl-slide-list>*{width:100%}.sl-slide-indicator{display:-webkit-flex;display:flex;-webkit-justify-content:center;justify-content:center;margin:6px 0}.sl-slide-indicator li{box-sizing:border-box;width:10px;height:10px;margin:0 5px;border:1px solid #d6d6d6;border-radius:50%}.sl-slide-current{background:#d6d6d6}";
styleInject(css$8,{"insertAt":"top"});

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "sl-slide"
  }, [_c("div", {
    staticClass: "sl-slide-list",
    on: {
      touchstart: function touchstart($event) {
        $event.stopPropagation();
        return _vm.touchStart($event);
      },
      touchmove: function touchmove($event) {
        $event.stopPropagation();
        return _vm.touchMove($event);
      },
      touchend: function touchend($event) {
        $event.stopPropagation();
        return _vm.touchEnd($event);
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c("ul", {
    staticClass: "sl-slide-indicator"
  }, _vm._l(_vm.childElementCount, function (n) {
    return _c("li", {
      class: {
        "sl-slide-current": n - 1 == _vm.page
      }
    });
  }), 0)]);
};

var __vue_staticRenderFns__$5 = [];
__vue_render__$5._withStripped = true;
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

var slSlide = normalizeComponent_1({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, undefined, undefined);

//
var script$6 = {
  components: {
    slSlide: slSlide
  },
  methods: {
    /**
     * 生成连续数字的数组
     * @param {Number} 开始数字
     * @param {Number} 结束数字
     * @returns {Array} 生成的连续数字的数组
     */
    numArr: function numArr(start, end) {
      var arr = [];

      for (var i = start; i <= end; i++) {
        arr.push(i);
      }

      return arr;
    },
    selectSticker: function selectSticker(event) {
      var target = event.target.nodeName.toLowerCase() == 'img' ? event.target : event.target.firstElementChild;

      if (target.nodeName.toLowerCase() == 'img') {
        this.$emit('select', target);
      }
    }
  }
};

var css$9 = ".sl-sticker{margin-top:12px;font-size:0}.sl-sticker-page{display:-webkit-flex;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap}.sl-sticker-page li{box-sizing:border-box;width:9vw;padding:3px}@media screen and (orientation:landscape){.sl-sticker-page li{width:6vw}}.sl-sticker-page img{width:100%}";
styleInject(css$9,{"insertAt":"top"});

/* script */
var __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("sl-slide", {
    staticClass: "sl-sticker",
    nativeOn: {
      click: function click($event) {
        return _vm.selectSticker($event);
      }
    }
  }, [_c("ul", {
    staticClass: "sl-sticker-page"
  }, _vm._l(27, function (n) {
    return _c("li", [_c("img", {
      attrs: {
        src: "//ossweb-img.qq.com/images/js/bsCommonFiles/images/qqemotion/" + n + ".png"
      }
    })]);
  }), 0), _vm._v(" "), _c("ul", {
    staticClass: "sl-sticker-page"
  }, _vm._l(_vm.numArr(28, 54), function (n) {
    return _c("li", [_c("img", {
      attrs: {
        src: "//ossweb-img.qq.com/images/js/bsCommonFiles/images/qqemotion/" + n + ".png"
      }
    })]);
  }), 0), _vm._v(" "), _c("ul", {
    staticClass: "sl-sticker-page"
  }, _vm._l(_vm.numArr(55, 81), function (n) {
    return _c("li", [_c("img", {
      attrs: {
        src: "//ossweb-img.qq.com/images/js/bsCommonFiles/images/qqemotion/" + n + ".png"
      }
    })]);
  }), 0), _vm._v(" "), _c("ul", {
    staticClass: "sl-sticker-page"
  }, _vm._l(_vm.numArr(82, 108), function (n) {
    return _c("li", [_c("img", {
      attrs: {
        src: "//ossweb-img.qq.com/images/js/bsCommonFiles/images/qqemotion/" + n + ".png"
      }
    })]);
  }), 0), _vm._v(" "), _c("ul", {
    staticClass: "sl-sticker-page"
  }, _vm._l(_vm.numArr(109, 114), function (n) {
    return _c("li", [_c("img", {
      attrs: {
        src: "//ossweb-img.qq.com/images/js/bsCommonFiles/images/qqemotion/" + n + ".png"
      }
    })]);
  }), 0)]);
};

var __vue_staticRenderFns__$6 = [];
__vue_render__$6._withStripped = true;
/* style */

var __vue_inject_styles__$6 = undefined;
/* scoped */

var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

var slSticker = normalizeComponent_1({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, undefined, undefined);

var script$7 = {
  components: {
    slTextarea: slTextarea,
    slSticker: slSticker
  },
  props: {
    comment: {
      // 所回复的评论的信息
      type: Object,
      default: function _default() {
        return {};
      }
    },
    reply: {
      // 所回复的评论下的楼层的信息
      type: Object,
      default: function _default() {
        return {};
      }
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showSticker: false,
      range: null,
      // 光标位置
      content: '',
      timer: 0
    };
  },
  watch: {
    'focus': function focus(nv) {
      var _this = this;

      if (nv) {
        this.timer = setTimeout(function () {
          _this.$refs.textarea.$el.focus(); // ios 无效：https://stackoverflow.com/questions/6287478/mobile-safari-autofocus-text-field

        }, 500);
      } else {
        clearTimeout(this.timer);
      }
    }
  },
  mounted: function mounted() {
    this.maxLength = 600; // 最大字符数
  },
  methods: {
    saveRange: function saveRange(range) {
      this.range = range;
    },
    toggleSticker: function toggleSticker() {
      this.showSticker = !this.showSticker;
    },

    /**
     * 选择表情
     * @param {Object} target - 所选表情 dom 节点
     */
    selectSticker: function selectSticker(target) {
      // 未选中编辑框，直接输入表情
      if (!this.range) {
        this.range = document.createRange();
        this.range.setStart(this.$refs.textarea.$el, 0);
      }

      var newNode = target.cloneNode();
      this.range.insertNode(newNode);
      this.range.setStartAfter(newNode);
      this.range.collapse(true);
    },
    submit: function submit() {
      var _this2 = this;

      this.showSticker = false;
      this.content = this.$refs.textarea.$el.innerHTML;
      var content = this.content.replace(/<img src="\/\/ossweb-img.qq.com\/images\/js\/bsCommonFiles\/images\/qqemotion\/(\d+)\.png".*?>/g, function ($1, $2) {
        return "[e:".concat($2, "]");
      });
      content = content.replace(/^((<div>)?((<br>|&nbsp; ?)+)(<\/div>)?)+|((<div>)?((<br>|&nbsp; ?)+)(<\/div>)?)+$/g, '');
      content = encodeUnicode(content);

      if (!content) {
        this.$toast("\u56DE\u590D\u5185\u5BB9\u4E0D\u80FD\u4E3A\u7A7A");
        return;
      }

      if (computeByteLength(content) > this.maxLength) {
        this.$toast("\u56DE\u590D\u5185\u5BB9\u4E0D\u80FD\u8D85\u8FC7 ".concat(this.maxLength, " \u5B57\u7B26\uFF08").concat(this.maxLength / 2, " \u6C49\u5B57\uFF09"));
        return;
      }

      if (this.comment.hasOwnProperty('commid')) {
        this.submitReply(content);
      } else {
        this.$comment.submitComment(content).then(function () {
          _this2.content = '';

          _this2.$emit('submit');
        });
      }
    },

    /**
     * 发表回复
     * @param {String} content - 回复内容
     */
    submitReply: function submitReply(content) {
      var _this3 = this;

      var _this$$comment = this.$comment,
          _config = _this$$comment._config,
          userInfo = _this$$comment.userInfo;
      this.$comment.ajax({
        url: 'SUBMIT_REPLY',
        data: {
          stime: this.comment.stime,
          objid: this.comment.objid,
          ctime: this.comment.ctime,
          commid: this.comment.commid,
          remark: this.reply.repid,
          resource_type: _config.options.resource_type || '',
          repid: userInfo.openid,
          avatar: userInfo.avatar,
          nickname: userInfo.nickname,
          content: content
        },
        success: function success(data) {
          _this3.$toast('回复成功');

          _this3.comment.replys.push({
            rtime: data.rtime,
            content: data.content,
            repid: userInfo.openid,
            repimgurl: userInfo.avatar,
            repname: userInfo.nickname,
            passrepname: _this3.reply.repname
          });

          _this3.content = '';

          _this3.$emit('submit');
        }
      });
    }
  }
};

var css$a = ".sl-reply-btn{display:-webkit-flex;-webkit-justify-content:flex-end;-webkit-align-items:center;display:flex;justify-content:flex-end;align-items:center;padding:6px 0}.sl-reply-emotion{width:24px;height:24px;margin:0 12px;background:url(//ossweb-img.qq.com/images/js/bsCommonFiles/images/qqemotion/emotion.png) no-repeat 50%/contain}.sl-reply-submit{display:-webkit-flex;-webkit-justify-content:center;-webkit-align-items:center;display:flex;justify-content:center;align-items:center;width:54px;height:30px;border-radius:4px;color:#fff;background:#5193ff}.sl-reply-textarea{height:78px;overflow:auto;margin:6px 0;border-bottom:1px solid rgba(0,0,0,.1);border-radius:2px;line-height:20px;font-size:15px;color:#919191;outline:none;-webkit-user-select:auto;user-select:auto}.comment-reply{padding:6px 12px;background:rgba(0,0,0,.06)}.comment-reply--textarea{height:78px;margin:6px 0;border:none!important;border-bottom:1px solid rgba(0,0,0,.1)!important;line-height:1.5;font-size:14px;color:#919191}.comment-reply--textarea img{display:inline-block;width:24px;vertical-align:middle}";
styleInject(css$a,{"insertAt":"top"});

/* script */
var __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "comment-reply"
  }, [_c("sl-textarea", {
    ref: "textarea",
    staticClass: "comment-reply--textarea",
    on: {
      range: _vm.saveRange
    },
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "sl-reply-btn"
  }, [_c("div", {
    staticClass: "sl-reply-emotion",
    on: {
      click: _vm.toggleSticker
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "sl-reply-submit",
    on: {
      click: _vm.submit
    }
  }, [_vm._v("发布")])]), _vm._v(" "), _c("sl-sticker", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSticker,
      expression: "showSticker"
    }],
    on: {
      select: _vm.selectSticker
    }
  })], 1);
};

var __vue_staticRenderFns__$7 = [];
__vue_render__$7._withStripped = true;
/* style */

var __vue_inject_styles__$7 = undefined;
/* scoped */

var __vue_scope_id__$7 = undefined;
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

var commentReply = normalizeComponent_1({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, undefined, undefined);

/**
 * @file 工具类 - 滚动
 * @author hardylin <hardylin@tencent.com>
 */
var scrollTop = 0; // 允许页面滚动

function allowScroll() {
  document.documentElement.classList.remove('comment-hidden');
  document.body.classList.remove('comment-hidden');
  document.body.scrollTop = scrollTop;
} // 阻止页面滚动

function preventScroll() {
  scrollTop = document.body.scrollTop;
  document.body.classList.add('comment-hidden');
  document.documentElement.classList.add('comment-hidden');
}

//
var script$8 = {
  name: 'comment-input',
  components: {
    CommentReply: commentReply
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    floor: {
      // 所回复的评论的信息
      type: Object,
      default: {}
    },
    layer: {
      // 所回复的评论下的楼层的信息
      type: Object,
      default: {}
    }
  },
  watch: {
    'show': function show(nv) {
      if (nv) {
        preventScroll();
      } else {
        allowScroll();
      }
    }
  },
  // mounted() {
  //     // 防止 fixed 在 transform 下无效的问题 @todo
  //     document.body.appendChild(this.$el)
  // },
  methods: {
    closePannel: function closePannel() {
      this.$emit('update:show', false);
    }
  }
};

var css$b = ".comment-input{z-index:980;position:fixed;top:0;left:0;width:100%;height:100%;text-align:left;color:#666;background:#fff}.comment-input--header{display:-webkit-flex;-webkit-justify-content:space-between;display:flex;justify-content:space-between;margin:12px;padding:0 6px}.comment-input--reply{margin:0 12px 12px}";
styleInject(css$b,{"insertAt":"top"});

var __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("transition", {
    attrs: {
      name: "comment-animate--slide"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "comment-input pop_reply"
  }, [_c("div", {
    staticClass: "comment-input--header"
  }, [_vm.layer.hasOwnProperty("repname") ? _c("div", [_vm._v("回复 " + _vm._s(_vm.layer.repname) + "：")]) : _vm.floor.hasOwnProperty("name") ? _c("div", [_vm._v("回复 " + _vm._s(_vm.floor.name) + "：")]) : _c("div", [_vm._v("发表新评论：")]), _vm._v(" "), _c("div", {
    staticClass: "comment--highlight",
    on: {
      click: _vm.closePannel
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c("comment-reply", {
    staticClass: "comment-input--reply",
    attrs: {
      comment: _vm.floor,
      reply: _vm.layer,
      focus: _vm.show
    },
    on: {
      submit: function submit($event) {
        return _vm.$emit("update:show", false);
      }
    }
  })], 1)]);
};

var __vue_staticRenderFns__$8 = [];
__vue_render__$8._withStripped = true;
/* style */

var __vue_inject_styles__$8 = undefined;
/* scoped */

var __vue_scope_id__$8 = undefined;
/* module identifier */

var __vue_module_identifier__$8 = undefined;
/* functional template */

var __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

var CommentInput = normalizeComponent_1({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, undefined, undefined);

//
var script$9 = {
  name: 'comment-report',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    floor: {
      // 所举报的评论的信息
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      reportObj: ['反动', '欺诈', '广告', '恶意营销', '色情低俗', '常识性谣言', '其他'],
      reportOption: -1
    };
  },
  watch: {
    'show': function show(newVal) {
      if (newVal) {
        preventScroll();
        this.reportOption = -1;
      } else {
        allowScroll();
      }
    }
  },
  // mounted() {
  //     // 防止 fixed 在 transform 下无效的问题 @todo
  //     document.body.appendChild(this.$el)
  // },
  methods: {
    closeReport: function closeReport() {
      this.$emit('update:show', false);
    },
    submit: function submit() {
      var _this = this;

      if (this.reportOption < 0) {
        this.$toast('请选择举报内容');
        return;
      }

      this.$comment.ajax({
        url: 'REPORT',
        data: {
          stime: this.floor.stime,
          objid: this.floor.objid,
          ctime: this.floor.ctime,
          commid: this.floor.commid,
          remark: encodeURIComponent(this.reportObj[this.reportOption])
        },
        success: function success() {
          _this.$toast('举报成功');

          _this.floor.report_status = 1;

          _this.$emit('update:show', false);
        }
      });
    }
  }
};

var css$c = ".np-comment-report-pop{z-index:980;position:fixed;top:0;left:0;right:0;bottom:0;overflow:auto;text-align:left;background:rgba(0,0,0,.6)}";
styleInject(css$c,{"insertAt":"top"});

/* script */
var __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("transition", {
    attrs: {
      name: "comment-animate--slide"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "np-comment-report-pop"
  }, [_c("div", {
    staticClass: "np-comment-report-bd"
  }, [_c("div", {
    staticClass: "report-title"
  }, [_c("a", {
    staticClass: "report-title-back",
    attrs: {
      href: "javascript:;",
      title: "返回"
    },
    on: {
      click: _vm.closeReport
    }
  }, [_vm._v("<")]), _vm._v("举报\n            ")]), _vm._v(" "), _c("div", {
    staticClass: "report-bd"
  }, [_c("h6", [_vm._v("请选择举报内容：")]), _vm._v(" "), _vm._l(_vm.reportObj, function (item, index) {
    return _c("ul", {
      key: index,
      staticClass: "report-options"
    }, [_c("li", {
      class: {
        selected: _vm.reportOption == index
      },
      on: {
        click: function click($event) {
          _vm.reportOption = index;
        }
      }
    }, [_c("span", [_vm._v(_vm._s(item))]), _vm._v(" "), _c("div", {
      staticClass: "report-options-item"
    })])]);
  }), _vm._v(" "), _c("div", {
    staticClass: "report-action"
  }, [_c("a", {
    staticClass: "report-sumbit",
    attrs: {
      href: "javascript:;",
      title: "提交"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("提交")])])], 2)])])]);
};

var __vue_staticRenderFns__$9 = [];
__vue_render__$9._withStripped = true;
/* style */

var __vue_inject_styles__$9 = undefined;
/* scoped */

var __vue_scope_id__$9 = undefined;
/* module identifier */

var __vue_module_identifier__$9 = undefined;
/* functional template */

var __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

var commentReport = normalizeComponent_1({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, undefined, undefined);

var _window = window,
    milo = _window.milo,
    need = _window.need;
var script$a = {
  name: 'comment-login',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isLogin: true
    };
  },
  mounted: function mounted() {
    this.initLogin(); // 防止 fixed 在 transform 下无效的问题

    document.body.appendChild(this.$el);
  },
  methods: {
    initLogin: function initLogin() {
      var _this = this;

      var login = this.$comment._config.login;

      if (process.env.NODE_ENV != 'production') {
        var silent = Vue.config.silent;
        Vue.config.silent = true; // 防止 Vue 捕获自定义错误，重复显示错误信息

        assert(milo && need, '缺少 milo，请引入：//ossweb-img.qq.com/images/js/mobile_bundle/milo.js');
        assert($, '缺少 zepto，请引入：//ossweb-img.qq.com/images/js/bsCommonFiles/library/zepto/zepto-1.2.0.min.js');
        assert(login && (login.wxappid || login.qqappid), '未检测到 MSDK 登录态，若需使用 微信 / QQ 登陆授权，构造函数参数需要包含 `login.wxappid` `login.qqappid` `login.openlink`');
        Vue.config.silent = silent;
      }

      need('biz.login', function (LoginManager) {
        _this.$comment.LoginManager = LoginManager;
        LoginManager.init({
          iUseQQConnect: _this.$comment._config.options.login_type === 'qqoidb' ? 1 : 0,
          appConfig: {
            QQBrowserAppId: 106,
            // 在 QQ 浏览器端申请的 appid，保持不变
            WxAppId: login.wxappid,
            // 需要申请微信 openLink 权限，联系人：johnnyliu(刘南江)
            AppName: login.appName || '',
            scope: login.scope || 'snsapi_userinfo',
            // milo 默认是 snsapi_base 静默授权
            LogoUrl: login.logoUrl || ''
          }
        });
        LoginManager.checkLogin(function (user) {
          if (milo.cookie.get('acctype') == 'wx') {
            // 微信登陆
            _this.loginByWechat(LoginManager);
          } else if (_this.$comment._config.options.login_type === 'qqoidb') {
            if (milo.cookie.get('acctype') == 'qc') {
              _this.loginByQC(LoginManager, user);
            } else {
              LoginManager.logout(function () {
                // qq互联登陆
                LoginManager.login({
                  iUseQQConnect: 1
                });
              });
            }
          } else {
            _this.loginByQQ(LoginManager, user);
          }
        }, function () {
          _this.autoLogin(); // QQ 浏览器特殊处理：登陆授权之后留在 QQ 浏览器内部浏览


          if (browser.qqBrowser) {
            var loginCallbackByQQBrowser = LoginManager.loginCallbackByQQBrowser;

            LoginManager.loginCallbackByQQBrowser = function (data) {
              loginCallbackByQQBrowser(data);
              setTimeout(function () {
                location.reload();
              }, 200);
            };
          }
        });
      });
    },

    /**
     * 微信登录授权
     * @param {Object} LoginManager - milo 登录管理对象
     */
    loginByWechat: function loginByWechat(LoginManager) {
      var _this2 = this;

      var openid = milo.cookie.get('appOpenId') || milo.cookie.get('openid');
      var access_token = navigator.userAgent.includes('GameHelper') ? milo.cookie.get('accessToken') : milo.cookie.get('access_token');
      this.$comment._vm.userInfo.openid = openid;
      this.$comment._login = {
        access_token: access_token,
        appid: this.$comment._config.login.wxappid,
        login_type: 'wxm'
      };
      this.$comment.requestCommentList(); // 获取用户头像昵称

      LoginManager.getUserInfoByWxOpenId({
        openid: openid,
        access_token: access_token
      }, function (wxuser) {
        _this2.$comment._vm.userInfo.avatar = wxuser.headimgurl ? wxuser.headimgurl + '/96' : '';
        _this2.$comment._vm.userInfo.nickname = wxuser.nickname && wxuser.nickname.replace(/<span class="emoji emoji(.)*?"><\/span>/g, '*');
      });
    },

    /**
         * QQ 互联授权
         * @param {Object} LoginManager - milo 登录管理对象
         * @param {Object} user - milo 登录成功的用户信息对象
         */
    loginByQC: function loginByQC(LoginManager, user) {
      var _this3 = this;

      var login_type = 'qqoidb';
      var access_token = getUrlParam('access_token');
      var openid = getUrlParam('openid');
      var appid = getUrlParam('appid');
      this.$comment._vm.userInfo.openid = openid;
      this.$comment._login = {
        access_token: access_token,
        openid: openid,
        appid: appid,
        login_type: login_type
      };
      this.$comment.requestCommentList(); // 获取用户头像昵称

      this.$comment._vm.userInfo.avatar = LoginManager.getNickName();
      LoginManager.getUserFace(function (data) {
        _this3.$comment._vm.userInfo.avatar = data.userFace;
      });
    },

    /**
     * QQ 登录授权
     * @param {Object} LoginManager - milo 登录管理对象
     * @param {Object} user - milo 登录成功的用户信息对象
     */
    loginByQQ: function loginByQQ(LoginManager, user) {
      var _this4 = this;

      this.$comment._login = {
        uin: milo.cookie.get('uin'),
        skey: milo.cookie.get('skey'),
        appid: this.$comment._config.login.qqappid,
        login_type: 'qqm'
      };
      this.$comment.ajax({
        url: 'USER_INFO',
        success: function success(data) {
          _this4.$comment._vm.userInfo.openid = data.openid;

          _this4.$comment.requestCommentList();
        }
      }); // 获取用户头像昵称

      if (user.nickName) {
        user.nickName = decodeURIComponent(user.nickName).replace(/<span class="emoji emoji(.)*?"><\/span>/g, '*');
      }

      this.$comment._vm.userInfo.nickname = user.nickName || getUrlParam('nickname') || getUrlParam('roleName') || '路人甲';
      LoginManager.getUserFace(function (data) {
        _this4.$comment._vm.userInfo.avatar = data.userFace;
      });
    },
    autoLogin: function autoLogin() {
      if (browser.wechat) {
        click(this.$el.querySelector('#wxloginBtn'));
      } else if (browser.qq) {
        click(this.$el.querySelector('#ptLoginBtn'));
      } else {
        this.isLogin = false;
        this.$comment.requestCommentList();
      }
    },

    /**
     * 拉起 app 进行登录
     * @param {String} app - 唤起登录授权的 app
     */
    login: function login(app) {
      // 过滤影响 QQ / 微信 自动登录的参数
      var url = location.href.replace(/(\?|&)(acctype|openid|state|token|toOpenid)=[^&#]*/g, function (str, str1) {
        return str1 === '?' ? '?' : '';
      });

      switch (app) {
        case 'qq':
          if (this.$comment._config.login.scheme === false) {
            this.$comment.LoginManager.login();
          } else {
            location.assign("mqqapi://forward/url?url_prefix=".concat(btoa(url), "&version=1&src_type=web"));
          }

          break;

        case 'wechat':
          location.assign(this.$comment._config.login.openlink);
          break;
      }
    }
  }
};

var css$d = ".comment-login{display:-webkit-flex;-webkit-flex-direction:column;-webkit-justify-content:center;-webkit-align-items:center;display:flex;flex-direction:column;justify-content:center;align-items:center;z-index:990;position:fixed;top:0;right:0;bottom:0;left:0;font-size:14px;color:#fff;background:rgba(0,0,0,.6)}.comment-login--close{position:absolute;top:0;left:0;width:100%;height:100%;padding:12px}[class|=comment-login--btn]{display:block;width:150px;height:36px;margin:5px 0;background:no-repeat 50%/contain}.comment-login--btn-qq{background-image:url(//ossweb-img.qq.com/images/js/bsCommonFiles/images/qqlogin.png)}.comment-login--btn-wechat{background-image:url(//ossweb-img.qq.com/images/js/bsCommonFiles/images/wxlogin.png)}";
styleInject(css$d,{"insertAt":"top"});

/* script */
var __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show && !_vm.isLogin,
      expression: "show && !isLogin"
    }],
    staticClass: "comment-login",
    on: {
      click: function click($event) {
        return _vm.$emit("update:show", false);
      }
    }
  }, [_c("div", {
    staticClass: "comment-login--btn-qq",
    on: {
      click: function click($event) {
        return _vm.login("qq");
      }
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "comment-login--btn-wechat",
    on: {
      click: function click($event) {
        return _vm.login("wechat");
      }
    }
  }), _vm._v(" "), _c("a", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "comment-login--btn-qq",
    attrs: {
      id: "ptLoginBtn",
      href: "javascript:;"
    }
  }), _vm._v(" "), _c("a", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "comment-login--btn-wechat",
    attrs: {
      id: "wxloginBtn",
      href: "javascript:;"
    }
  })]);
};

var __vue_staticRenderFns__$a = [];
__vue_render__$a._withStripped = true;
/* style */

var __vue_inject_styles__$a = undefined;
/* scoped */

var __vue_scope_id__$a = undefined;
/* module identifier */

var __vue_module_identifier__$a = undefined;
/* functional template */

var __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

var commentLogin = normalizeComponent_1({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, undefined, undefined);

var script$b = {
  components: {
    commentItem: CommentItem,
    commentReply: commentReply,
    commentAddBar: AddBar,
    commentAddButton: AddButton,
    commentInput: CommentInput,
    commentReport: commentReport,
    commentLogin: commentLogin
  },
  name: 'comment-main',
  props: {
    mini: {
      // 简化回复信息
      type: Boolean,
      default: false
    },
    actionBtn: {
      // 显示操作按钮
      type: Boolean,
      default: true
    },
    respond: {
      // 是否可以回复评论
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      login: {
        show: false
      },
      input: {
        show: false,
        floor: {},
        layer: {}
      },
      report: {
        show: false,
        floor: {}
      },
      officialAccount: {}
    };
  },
  computed: {
    total: function total() {
      return this.$comment.comments.total;
    },
    hot: function hot() {
      return this.$comment.comments.hot;
    },
    latest: function latest() {
      return this.$comment.comments.latest;
    }
  },
  mounted: function mounted() {
    var _this$$comment$_confi = this.$comment._config.infinite,
        infinite = _this$$comment$_confi === void 0 ? 'scroll' : _this$$comment$_confi;

    if (infinite == 'scroll') {
      window.addEventListener('scroll', this.scrollEvent.bind(this));
    }

    this.eventListener();
  },
  beforeDestroy: function beforeDestroy() {
    var _this$$comment$_confi2 = this.$comment._config.infinite,
        infinite = _this$$comment$_confi2 === void 0 ? 'scroll' : _this$$comment$_confi2;

    if (infinite == 'scroll') {
      window.removeEventListener('scroll', this.scrollEvent);
    }
  },
  activated: function activated() {
    this.activate = true;
  },
  deactivated: function deactivated() {
    this.activate = false;
  },
  methods: {
    scrollEvent: function scrollEvent() {
      if (Math.max(document.body.scrollTop, document.documentElement.scrollTop) > document.body.offsetHeight - window.innerHeight * 1.5) {
        this.$comment.requestCommentList();
      }
    },
    eventListener: function eventListener() {
      var _this = this;

      // 点击头像
      this.$comment._vm.$on('avatarClick', function (comment) {
        if (_this.$comment._login.login_type) {
          if (typeof _this.$comment._config.events.onAvatarClick === 'function') {
            _this.$comment._config.events.onAvatarClick(comment);
          } else {
            _this.$emit('avatar-click', comment);
          }
        } else {
          _this.$comment._vm.$emit('login');
        }
      }); // 弹出输入框


      this.$comment._vm.$on('input', function () {
        // 防止 keep-alive 时同时响应事件
        if (_this.activate === false) {
          return;
        }

        if (_this.$comment._login.login_type) {
          _this.input.floor = {};
          _this.input.show = true;
        } else {
          _this.$comment._vm.$emit('login');
        }
      }); // 弹出登录界面


      this.$comment._vm.$on('login', function () {
        _this.login.show = true;
      });
    },
    requestComments: function requestComments() {
      if (this.$comment._config.infinite == 'click') {
        this.$comment.requestCommentList();
      }
    },

    /**
     * 举报评论
     * @param {Object} comment - 评论对象
     */
    reportComment: function reportComment(comment) {
      this.report.floor = comment;
      this.report.show = true;
    },

    /**
     * 删除评论
     * @param {Object} comment - 评论对象
     * @param {Number} index - 评论索引
     * @param {Number} list - 评论所在列表
     */
    deleteComment: function deleteComment(comment, index, list) {
      var _this2 = this;

      this.$comment.ajax({
        url: 'DELETE_COMMENT',
        data: {
          stime: comment.stime,
          objid: comment.objid,
          commid: comment.commid,
          ctime: comment.ctime
        },
        success: function success() {
          _this2[list].splice(index, 1);

          _this2.$comment.comments.total -= 1;

          _this2.$toast('删除成功');
        }
      });
    },

    /**
     * 回复评论
     * @param {Object} comment - 评论对象
     * @param {Object} reply - 回复对象
     */
    replyComment: function replyComment(comment, reply) {
      if (window.__UgcConfig && window.__UgcConfig.comment === false) {
        // this.$comment._vm.$toast(window.__UgcConfig.tips)
        return;
      }

      if (!this.respond) {
        return;
      }

      if (this.$comment._login.login_type) {
        this.input.floor = comment;
        this.input.layer = reply ? reply : {};
        this.input.show = true;
      } else {
        this.$comment._vm.$emit('login');
      }
    }
  }
};

var css$e = ".comment-main{text-align:left}.comment-main--tips{display:-webkit-flex;-webkit-justify-content:center;-webkit-align-items:center;display:flex;justify-content:center;align-items:center;height:100px}.comment-main .comment-reply{margin:0 12px 12px}.allComments>.vc-item:first-child{background:none}";
styleInject(css$e,{"insertAt":"top"});

var css$f = ".comment-main{font-size:14px;color:#333}.comment-main--header{display:-webkit-flex;-webkit-justify-content:space-between;-webkit-align-items:center;display:flex;justify-content:space-between;align-items:center;padding:12px}.comment-main--header-text{margin-right:12px}.comment-main--header-prompt{margin-top:6px;font-size:12px;color:grey}.comment-main--title{display:-webkit-flex;-webkit-align-items:center;display:flex;align-items:center;height:40px;border-top:10px solid rgba(0,0,0,.05);padding:0 12px}.comment--theme-dark.comment-main{color:#999}.comment--theme-dark .comment-main--title{border-top:10px solid rgba(0,0,0,.1)}";
styleInject(css$f,{"insertAt":"top"});

/* script */
var __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "np-frame comment-main",
    class: ["comment--theme-" + _vm.$comment._config.theme]
  }, [_c("div", {
    staticClass: "comment-main--header"
  }, [_c("div", {
    staticClass: "comment-main--header-text"
  }, [_c("div", [_vm._v("网友评论（" + _vm._s(_vm.total) + "条评论）")]), _vm._v(" "), _c("div", {
    staticClass: "comment-main--header-prompt"
  }, [_vm._v("* 请不要轻信评论中出现的充值，代练等虚假信息 *")])]), _vm._v(" "), this.$comment._config.replyMode == "button" ? _c("comment-add-button") : _vm._e()], 1), _vm._v(" "), _vm.$comment._config.replyMode == "inline" ? _c("comment-reply") : _vm._e(), _vm._v(" "), _vm.hot.length > 0 ? [_c("div", {
    staticClass: "comment-main--title comment--highlight"
  }, [_vm._v("热门评论")]), _vm._v(" "), _vm._l(_vm.hot, function (comment, index) {
    return _c("comment-item", {
      key: "hot" + index,
      attrs: {
        comment: comment,
        mini: _vm.mini,
        "action-btn": _vm.actionBtn
      },
      on: {
        delete: function _delete($event) {
          return _vm.deleteComment(comment, index, "hot");
        },
        reply: _vm.replyComment,
        report: function report($event) {
          return _vm.reportComment(comment);
        },
        login: function login($event) {
          return _vm.$comment._vm.$emit("login");
        }
      }
    });
  })] : _vm._e(), _vm._v(" "), [_c("div", {
    staticClass: "comment-main--title comment--highlight"
  }, [_vm._v("最新评论")]), _vm._v(" "), _vm._l(_vm.latest, function (comment, index) {
    return _c("comment-item", {
      attrs: {
        comment: comment,
        mini: _vm.mini,
        "action-btn": _vm.actionBtn
      },
      on: {
        delete: function _delete($event) {
          return _vm.deleteComment(comment, index, "latest");
        },
        reply: _vm.replyComment,
        report: function report($event) {
          return _vm.reportComment(comment);
        },
        login: function login($event) {
          return _vm.$comment._vm.$emit("login");
        }
      }
    });
  })], _vm._v(" "), _c("div", {
    staticClass: "comment-main--tips"
  }, [_c("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$comment.comments.status.more && !_vm.$comment.comments.status.busy,
      expression: "$comment.comments.status.more && !$comment.comments.status.busy"
    }],
    on: {
      click: _vm.requestComments
    }
  }, [_vm._v(_vm._s(_vm.$comment._config.infinite == "click" ? "点击" : "上拉") + "显示更多")]), _vm._v(" "), _c("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$comment.comments.status.busy,
      expression: "$comment.comments.status.busy"
    }]
  }, [_vm._v("正在加载...")]), _vm._v(" "), !_vm.$comment.comments.status.more && _vm.$comment.comments.latest.length > 0 ? _c("span", [_vm._v("已显示全部评论")]) : _vm._e(), _vm._v(" "), !_vm.$comment.comments.status.more && _vm.$comment.comments.latest.length == 0 ? _c("span", [_vm._v("还没有人发表过评论喔~")]) : _vm._e()]), _vm._v(" "), this.$comment._config.replyMode == "bar" ? _c("comment-add-bar", [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _c("comment-input", {
    attrs: {
      show: _vm.input.show,
      floor: _vm.input.floor,
      layer: _vm.input.layer
    },
    on: {
      "update:show": function updateShow($event) {
        return _vm.$set(_vm.input, "show", $event);
      }
    }
  }), _vm._v(" "), _c("comment-report", {
    attrs: {
      show: _vm.report.show,
      floor: _vm.report.floor
    },
    on: {
      "update:show": function updateShow($event) {
        return _vm.$set(_vm.report, "show", $event);
      }
    }
  }), _vm._v(" "), _vm.$comment._login.login_type != "msdkv5" && _vm.$comment._login.login_type != "msdk" && _vm.$comment._login.login_type != "qqm" && _vm.$comment._login.login_type != "wxm" && _vm.$comment._login.login_type != "wxapp" ? _c("comment-login", {
    attrs: {
      show: _vm.login.show
    },
    on: {
      "update:show": function updateShow($event) {
        return _vm.$set(_vm.login, "show", $event);
      }
    }
  }) : _vm._e()], 2);
};

var __vue_staticRenderFns__$b = [];
__vue_render__$b._withStripped = true;
/* style */

var __vue_inject_styles__$b = undefined;
/* scoped */

var __vue_scope_id__$b = undefined;
/* module identifier */

var __vue_module_identifier__$b = undefined;
/* functional template */

var __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

var Main = normalizeComponent_1({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, undefined, undefined);

var script$c = {
  name: 'comment-mine',
  components: {
    CommentItem: CommentItem,
    CommentInput: CommentInput
  },
  props: {
    prompt: {
      type: String,
      default: '您还没有发表过评论喔~'
    },
    respond: {
      // 是否可以回复评论中的回复
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      input: {
        show: false,
        floor: {},
        layer: {}
      }
    };
  },
  computed: {
    comments: function comments() {
      return this.$comment.comments.own;
    }
  },
  mounted: function mounted() {
    this.$comment.requestOwnComments();
    var _this$$comment$_confi = this.$comment._config.infinite,
        infinite = _this$$comment$_confi === void 0 ? 'scroll' : _this$$comment$_confi;

    if (infinite == 'scroll') {
      window.addEventListener('scroll', this.scrollEvent.bind(this));
    }
  },
  beforeDestroy: function beforeDestroy() {
    var _this$$comment$_confi2 = this.$comment._config.infinite,
        infinite = _this$$comment$_confi2 === void 0 ? 'scroll' : _this$$comment$_confi2;

    if (infinite == 'scroll') {
      window.removeEventListener('scroll', this.scrollEvent);
    }
  },
  methods: {
    scrollEvent: function scrollEvent() {
      if (Math.max(document.body.scrollTop, document.documentElement.scrollTop) > document.body.offsetHeight - window.innerHeight * 1.5) {
        this.$comment.requestOwnComments();
      }
    },

    /**
     * 删除评论
     * @param {Object} comment - 评论对象
     * @param {Number} index - 评论索引
     */
    deleteComment: function deleteComment(comment, index) {
      var _this = this;

      this.$comment.ajax({
        url: 'DELETE_COMMENT',
        data: {
          stime: comment.stime,
          objid: comment.objid,
          commid: comment.commid,
          ctime: comment.ctime
        },
        success: function success() {
          _this.comments.splice(index, 1);

          _this.$toast('删除成功');
        }
      });
    },

    /**
     * 回复评论
     * @param {Object} comment - 评论对象
     * @param {Object} reply - 回复对象
     */
    replyComment: function replyComment(comment, reply) {
      if (window.__UgcConfig && window.__UgcConfig.comment === false) {
        // this.$toast(window.__UgcConfig.tips)
        return;
      } // 评论强制不能回复，只能控制评论中的回复


      if (!this.respond || !reply) {
        return;
      }

      this.input.floor = comment;
      this.input.layer = reply ? reply : {};
      this.input.show = true;
    }
  }
};

var css$g = ".comment-mine{font-size:14px;text-align:left;color:#333}.comment-mine--prompt{display:-webkit-flex;-webkit-justify-content:center;-webkit-align-items:center;display:flex;justify-content:center;align-items:center;height:100px}.comment--theme-dark.comment-mine{color:#999}";
styleInject(css$g,{"insertAt":"top"});

/* script */
var __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "comment-mine",
    class: ["comment--theme-" + _vm.$comment._config.theme]
  }, [!_vm.$comment.comments.ownStatus.more && _vm.comments.length == 0 ? _c("p", {
    staticClass: "comment-mine--prompt"
  }, [_vm._v(_vm._s(_vm.prompt))]) : _vm._e(), _vm._v(" "), _vm._l(_vm.comments, function (comment, index) {
    return _c("comment-item", {
      attrs: {
        comment: comment,
        from: true,
        mini: true,
        "action-btn": false
      },
      on: {
        delete: function _delete($event) {
          return _vm.deleteComment(comment, index);
        },
        reply: _vm.replyComment
      }
    });
  }), _vm._v(" "), _c("comment-input", {
    attrs: {
      show: _vm.input.show,
      floor: _vm.input.floor,
      layer: _vm.input.layer
    },
    on: {
      "update:show": function updateShow($event) {
        return _vm.$set(_vm.input, "show", $event);
      }
    }
  })], 2);
};

var __vue_staticRenderFns__$c = [];
__vue_render__$c._withStripped = true;
/* style */

var __vue_inject_styles__$c = undefined;
/* scoped */

var __vue_scope_id__$c = undefined;
/* module identifier */

var __vue_module_identifier__$c = undefined;
/* functional template */

var __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

var Mine = normalizeComponent_1({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, undefined, undefined);

/**
 * @file 评论组件安装模块
 * @author hardylin <hardylin@tencent.com>
 */
var _Vue = null;
function install(Vue) {
  if (_Vue) return;

  if (process.env.NODE_ENV != 'production') {
    assert(Vue.version >= '2.3', 'vue 版本必须大于 2.3.0');
  }

  _Vue = Vue;
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var options = this.$options;

      if (options.comment) {
        this.$comment = options.comment;
      } else if (options.parent && options.parent.$comment) {
        this.$comment = options.parent.$comment;
      }
    }
  });
  Vue.component('comment-barrage', Barrage);
  Vue.component('comment-add-bar', AddBar);
  Vue.component('comment-add-button', AddButton);
  Vue.component('comment-main', Main);
  Vue.component('comment-mine', Mine);
}

var Comment =
/*#__PURE__*/
function () {
  _createClass(Comment, null, [{
    key: "install",
    value: function install() {} // 静态方法，用于 Vue 插件安装

    /**
     * @constructs Comment
     * @param {Object} config - 参数配置项
     */

  }]);

  function Comment(config) {
    var _this = this;

    _classCallCheck(this, Comment);

    this._config = config;
    this.setDefaultValue();
    this._login = {};
    this._vm = new Vue({
      data: {
        comments: {
          hot: [],
          latest: [],
          total: 0,
          status: {
            busy: false,
            // 是否正在请求
            more: true // 是否还有更多

          },
          own: [],
          ownStatus: {
            busy: false,
            more: true
          }
        },
        userInfo: {
          openid: '',
          avatar: '',
          nickname: ''
        },
        officialAccount: {} // 官方账号

      }
    }); // 获取官方账号

    loadScript('//ossweb-img.qq.com/images/js/bsCommonFiles/js/officialAccount.js').then(function () {
      _this._vm.officialAccount = window.officialAccount;
    }); // 有登录态与资源 id 则自动请求首页评论

    if (this._isMSDK() || this._isApp() || this._isWechatApp() || this._isQQC()) {
      this.requestCommentList();
    }

    if (config.el) {
      new Vue({
        el: config.el,
        comment: this,
        render: function render(h) {
          return h('comment-main');
        }
      });
    }
  }

  _createClass(Comment, [{
    key: "setDefaultValue",
    value: function setDefaultValue() {
      if (!this._config.hasOwnProperty('replyMode')) {
        this._config.replyMode = 'bar';
      }

      if (!this._config.hasOwnProperty('theme')) {
        this._config.theme = 'light';
      }

      if (!this._config.hasOwnProperty('env')) {
        this._config.env = process.env.NODE_ENV;
      }
    }
    /**
     * 判断是否为 QQ互联url形式 登录
     */

  }, {
    key: "_isQQC",
    value: function _isQQC() {
      var _this2 = this;

      var search = '';

      if (location.search.includes('login_type=qqoidb')) {
        search = location.search;
      } else {
        search = sessionStorage.tokenParams || sessionStorage.dataSearch || '';
      }

      if (search.includes('qqoidb')) {
        sessionStorage.tokenParams = search;
        sessionStorage.dataSearch = search;
        var login_type = getUrlParam('login_type', search);
        var appid = getUrlParam('appid', search);
        var openid = getUrlParam('openid', search);
        var access_token = getUrlParam('access_token', search); // 登录类型（msdk：默认值，wxapp：微信小程序，wxpc：pc 官网微信，wxm：移动官网微信，qqpc：pc 官网 QQ，qqm：移动官网 QQ）

        this._login = {
          login_type: login_type,
          appid: appid,
          openid: openid,
          access_token: access_token
        };
        debugger;
        this.ajax({
          url: 'USER_INFO',
          success: function success(data) {
            _this2._vm.userInfo = {
              openid: getUrlParam('openid', search),
              avatar: data.avatar,
              nickname: data.nickname
            };
          }
        });
        return true;
      } else {
        return false;
      }
    }
    /**
     * 判断是否为 MSDK 登录
     */

  }, {
    key: "_isMSDK",
    value: function _isMSDK() {
      var _this3 = this;

      var search = '';

      if (location.search.includes('msdkEncodeParam=')) {
        search = location.search;
      } else if (location.search.includes('itopencodeparam=')) {
        search = location.search.replace("gameid=", "gameid_v5=") + "&login_type=msdkv5";
      } else {
        search = sessionStorage.tokenParams || sessionStorage.dataSearch || '';
      }

      if (search.includes('msdkEncodeParam=') || search.includes('itopencodeparam=')) {
        sessionStorage.tokenParams = search;
        sessionStorage.dataSearch = search; // 登录类型（msdk：默认值，wxapp：微信小程序，wxpc：pc 官网微信，wxm：移动官网微信，qqpc：pc 官网 QQ，qqm：移动官网 QQ）

        this._login.login_type = search.includes('msdkEncodeParam=') ? 'msdk' : 'msdkv5';
        this.ajax({
          url: 'USER_INFO',
          success: function success(data) {
            _this3._vm.userInfo = {
              openid: getUrlParam('openid', search),
              avatar: data.avatar,
              nickname: data.nickname
            };
          }
        });
        return true;
      } else {
        return false;
      }
    }
    /**
     * 判断是否为 app 登录（趣鱿）
     */

  }, {
    key: "_isApp",
    value: function _isApp() {
      var login_type = getUrlParam('login_type');
      var session_id = getUrlParam('session_id');
      var openid = getUrlParam('openid');
      var avatar = getUrlParam('avatar');
      var nickname = getUrlParam('nickname');

      if (login_type && session_id && openid && avatar && nickname) {
        this._login = {
          login_type: login_type,
          session_id: session_id
        };
        this._vm.userInfo = {
          openid: openid,
          avatar: avatar,
          nickname: nickname
        };
        return true;
      } else {
        return false;
      }
    }
    /**
     * 判断是否为微信小程序登录
     */

  }, {
    key: "_isWechatApp",
    value: function _isWechatApp() {
      var login_type = getUrlParam('login_type');
      var session_id = getUrlParam('session_id');
      var openid = getUrlParam('openid');
      var avatar = getUrlParam('avatar');
      var nickname = getUrlParam('nickname');
      var wxapp_channelid = getUrlParam('wxapp_channelid');

      if (login_type && session_id && avatar && nickname) {
        this._login = {
          login_type: login_type,
          session_id: session_id,
          wxapp_channelid: wxapp_channelid
        };
        this._vm.userInfo = {
          openid: openid,
          avatar: avatar,
          nickname: nickname
        };
        return true;
      } else {
        return false;
      }
    }
    /**
     * ajax 请求封装
     * @param {Object} options - ajax 请求参数，选项与 jquery / zepto 一致
     */

  }, {
    key: "ajax",
    value: function ajax() {
      var _this4 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      /* #region 清除无用的 appid（王者助手 app 特殊逻辑） */
      var _window = window,
          milo = _window.milo;

      if (milo && milo.cookie.get('appid') === '') {
        milo.cookie.clear('appid', 'qq.com', '/');
      }
      /* #endregion */


      var _this$_config$options = this._config.options,
          gameid = _this$_config$options.gameid,
          _this$_config$options2 = _this$_config$options.channel,
          channel = _this$_config$options2 === void 0 ? 1 : _this$_config$options2;

      if (process.env.NODE_ENV != 'production') {
        assert(typeof gameid == 'string', '配置参数项 `options.gameid` 错误');
      }

      var url = options.url,
          _options$data = options.data,
          data = _options$data === void 0 ? {} : _options$data,
          success = options.success,
          error = options.error;
      /* #region 请求参数处理 */

      options.data = Object.assign({
        channel: channel,
        gameid: gameid,
        busikey: 'all_mobile',
        sandbox: this._config.env != 'production' ? 1 : 0
      }, data, this._login);

      if (!this._login.hasOwnProperty('openid') && this._login.login_type != 'msdk' && this._login.login_type != 'msdkv5') {
        options.data.openid = this.userInfo.openid;
      }
      /* #endregion */


      jsonp({
        url: "https://".concat(this._config.env != 'production' ? 'appt' : 'app', ".ingame.qq.com/php/ingame/comment").concat(API[url]).concat(this._login.login_type == 'msdk' || this._login.login_type == 'msdkv5' ? sessionStorage.tokenParams : ''),
        data: options.data
      }).then(function (result) {
        if (result.status == 'SUCCESS') {
          typeof success == 'function' && success(result.data);
        } else {
          var _data = result.data;

          if (_data && _data.code == -1024) {
            _this4.LoginManager && _this4.LoginManager.logout(); // 解决跳转 QQ 登录页面白屏又跳回来的问题

            _this4._vm.$emit('login');
          } else if (_data && _data.code == 3000) {
            _this4._vm.$toast('您的账号存在违规操作，暂时无法使用评论功能！', 'center');
          } else {
            _this4._vm.$toast(result.msg, 'center');
          } // 自定义错误回调


          if (typeof error == 'function') {
            error(result);
          }
        }
      });
    }
    /**
     * 请求评论列表
     */

  }, {
    key: "requestCommentList",
    value: function requestCommentList() {
      var _this$_config$options3 = this._config.options,
          _this$_config$options4 = _this$_config$options3.title,
          title = _this$_config$options4 === void 0 ? document.title : _this$_config$options4,
          stime = _this$_config$options3.stime,
          objid = _this$_config$options3.objid,
          moduleId = _this$_config$options3.moduleId,
          _this$_config$options5 = _this$_config$options3.num,
          num = _this$_config$options5 === void 0 ? 7 : _this$_config$options5,
          _this$_config$options6 = _this$_config$options3.hotnum,
          hotnum = _this$_config$options6 === void 0 ? 3 : _this$_config$options6,
          _this$_config$options7 = _this$_config$options3.hotlevel,
          hotlevel = _this$_config$options7 === void 0 ? 10 : _this$_config$options7; // 初始化时参数不全则不自动加载评论，需要自行使用 refresh 进行刷新加载

      if (!objid) {
        return;
      }

      if (process.env.NODE_ENV != 'production') {
        assert(/^\d{6}$/.test(stime), '配置参数项 `options.stime` 错误');
        assert(typeof moduleId == 'string', '配置参数项 `options.moduleId` 错误');
        assert(num >= 5 && num <= 10, '配置参数项 `options.num` 可选值范围为 5 - 10');
      }

      var comments = this._vm.comments;

      if (comments.status.busy || !comments.status.more) {
        return;
      }

      comments.status.busy = true;
      this.ajax({
        url: 'COMMENT_LIST',
        data: {
          title: title,
          stime: stime,
          objid: objid + '_' + moduleId,
          num: num,
          hotnum: hotnum,
          hotlevel: hotlevel,
          action: comments.latest.length > 0 ? 'list' : 'init',
          ltime: comments.total ? comments.latest[comments.latest.length - 1].ctime : 0
        },
        success: function success(data) {
          comments.latest = comments.latest.concat(data.latest);

          if (comments.total) {
            if (data.latest.length < num) {
              comments.status.more = false;
            }
          } else {
            comments.hot = data.hot;
            comments.total = data.total_comment_num;

            if (data.total_comment_num <= num) {
              comments.status.more = false;
            }
          }

          comments.status.busy = false;
        }
      });
    }
    /**
     * 请求自身评论
     */

  }, {
    key: "requestOwnComments",
    value: function requestOwnComments() {
      var _this$_config$options8 = this._config.options.num,
          num = _this$_config$options8 === void 0 ? 8 : _this$_config$options8;

      if (process.env.NODE_ENV != 'production') {
        assert(num >= 5 && num <= 10, '配置参数项 `options.num` 可选值范围为 5 - 10');
      }

      var comments = this._vm.comments;

      if (comments.ownStatus.busy || !comments.ownStatus.more) {
        return;
      }

      comments.ownStatus.busy = true;
      this.ajax({
        url: 'USER_COMMENT_LIST',
        data: {
          num: num,
          lrtime: comments.own[comments.own.length - 1] ? comments.own[comments.own.length - 1].lrtime : 0
        },
        success: function success(data) {
          var result = data && data.comments ? data.comments : [];
          comments.own = comments.own.concat(result);

          if (result.length < num) {
            comments.ownStatus.more = false;
          }

          comments.ownStatus.busy = false;
        }
      });
    }
    /**
     * 发表评论
     * @param {String} content - 发表内容
     * @returns {Object} - Promise 实例
     */

  }, {
    key: "submitComment",
    value: function submitComment(content) {
      var _this5 = this;

      if (window.__UgcConfig && window.__UgcConfig.comment === false) {
        this._vm.$toast(window.__UgcConfig.tips);

        return;
      }

      return new Promise(function (resolve, reject) {
        var _this5$_config$option = _this5._config.options,
            _this5$_config$option2 = _this5$_config$option.title,
            title = _this5$_config$option2 === void 0 ? document.title : _this5$_config$option2,
            stime = _this5$_config$option.stime,
            objid = _this5$_config$option.objid,
            moduleId = _this5$_config$option.moduleId,
            _this5$_config$option3 = _this5$_config$option.resource_type,
            resource_type = _this5$_config$option3 === void 0 ? '' : _this5$_config$option3,
            _this5$_config$option4 = _this5$_config$option.href,
            href = _this5$_config$option4 === void 0 ? location.href.replace(/(\?|&)(algorithm|appid|area|encode|msdkEncodeParam|openid|partition|physicalID|roleid|sig|timestamp|version)=[^&#]*/g, function (str, str1) {
          return str1 === '?' ? '?' : '';
        }) : _this5$_config$option4;

        _this5.ajax({
          url: 'SUBMIT_COMMENT',
          data: {
            title: title,
            stime: stime,
            objid: objid + '_' + moduleId,
            commid: _this5.userInfo.openid,
            avatar: _this5.userInfo.avatar,
            nickname: _this5.userInfo.nickname,
            resource_type: resource_type,
            obj_url_mobile: href,
            content: content
          },
          success: function success(data) {
            _this5._vm.$toast('发表成功');

            _this5._vm.comments.latest.unshift({
              stime: stime,
              objid: objid + '_' + moduleId,
              ctime: data.ctime,
              content: data.content,
              commid: _this5.userInfo.openid,
              imgurl: _this5.userInfo.avatar,
              name: _this5.userInfo.nickname,
              rnum: 0,
              likenum: 0,
              oper_status: 0,
              report_status: 0,
              replys: []
            });

            _this5._vm.comments.total += 1;
            resolve();
          },
          error: reject
        });
      });
    }
    /**
     * 刷新评论组件
     * @param {Object} [config = {}] - 参数配置项，与构造函数一致
     */

  }, {
    key: "refresh",
    value: function refresh() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _config$options = config.options,
          options = _config$options === void 0 ? {} : _config$options;
      Object.assign(this._config.options, options); // 初始化

      this._vm.comments = {
        hot: [],
        latest: [],
        total: 0,
        status: {
          busy: false,
          more: true
        },
        own: [],
        ownStatus: {
          busy: false,
          more: true
        }
      };
      this.requestCommentList();
    }
    /**
     * 
     */

  }, {
    key: "comments",
    get: function get() {
      return this._vm.comments;
    }
  }, {
    key: "userInfo",
    get: function get() {
      return this._vm.userInfo;
    }
  }]);

  return Comment;
}();
Comment.install = install;
Comment.version = version;

if (window.Vue) {
  window.Vue.use(Comment);
}

export default Comment;
